import "react-datepicker/dist/react-datepicker.css";
import 'react-toastify/dist/ReactToastify.css';

import { Button, ButtonGroup, Card, Col, Dropdown, Form, Modal, Offcanvas, Row } from 'react-bootstrap';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { faCar, faChevronLeft, faChevronRight, faCopy, faEdit, faExclamationCircle, faInfoCircle, faPlus, faRuler, faSave, faSearch, faTimes, faTrash, faWalking } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useParams } from 'react-router-dom';

import Clock from './Clock';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MainContext } from '../App';
import apiService from "../api";

const GOOGLE_MAPS_API_KEY = 'AIzaSyD8U7srHPskMAoVGKRdRgqEGUUWh9EW6oE';

const days = ['Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct', 'Pz']
const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']

const turkishLocale = {
  code: 'tr',
  formatLong: {
    date: () => 'dd/MM/yyyy'
  },
  localize: {
    ordinalNumber: (n) => `${n}.`,
    era: (n) => n === 1 ? 'MS' : 'MÖ',
    quarter: (n) => `${n}. çeyrek`,
    month: (n) => months[n],
    day: (n) => days[n],
    dayPeriod: (n) => n === 'am' ? 'ÖÖ' : 'ÖS'
  },
  match: {
    ordinalNumber: /^(\d+)(\.)?/i,
    era: /^(mö|ms)/i,
    quarter: /^[1-4](\.|\. çeyrek)?/i,
    month: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i,
    day: /^(pt|sa|ça|pe|cu|ct|pz)/i,
    dayPeriod: /^(öö|ös)/i
  },
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}

const formatPhoneNumber = (phone) => {
  if (!phone) return null;
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return `+90 (${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)} ${cleaned.slice(6, 8)} ${cleaned.slice(8, 10)}`;
  }
  return phone;
};

export const monthNameMap = [
  "Ocak",
  "Şubat",
  "Mart",
  "Nisan",
  "Mayıs",
  "Haziran",
  "Temmuz",
  "Ağustos",
  "Eylül",
  "Ekim",
  "Kasım",
  "Aralık"
];

export const hourDateOptions = [
  <option key="1">0</option>,
  <option key="2">1</option>,
  <option key="3">2</option>,
  <option key="4">3</option>,
  <option key="5">4</option>,
  <option key="6">5</option>,
  <option key="7">6</option>,
  <option key="8">7</option>,
  <option key="9">8</option>,
  <option key="10">9</option>,
  <option key="11">10</option>,
  <option key="12">11</option>,
  <option key="13">12</option>,
  <option key="14">13</option>,
  <option key="15">14</option>,
  <option key="16">15</option>,
  <option key="17">16</option>,
  <option key="18">17</option>,
  <option key="19">18</option>,
  <option key="20">19</option>,
  <option key="21">20</option>,
  <option key="22">21</option>,
  <option key="23">22</option>,
  <option key="24">23</option>
]

export const monthDateOptions = [
  <option key="1" value="0">{monthNameMap[0]}</option>,
  <option key="2" value="1">{monthNameMap[1]}</option>,
  <option key="3" value="2">{monthNameMap[2]}</option>,
  <option key="4" value="3">{monthNameMap[3]}</option>,
  <option key="5" value="4">{monthNameMap[4]}</option>,
  <option key="6" value="5">{monthNameMap[5]}</option>,
  <option key="7" value="6">{monthNameMap[6]}</option>,
  <option key="8" value="7">{monthNameMap[7]}</option>,
  <option key="9" value="8">{monthNameMap[8]}</option>,
  <option key="10" value="9">{monthNameMap[9]}</option>,
  <option key="11" value="10">{monthNameMap[10]}</option>,
  <option key="12" value="11">{monthNameMap[11]}</option>
]

export const yearDateOptions = [
  <option key="1">2023</option>,
  <option key="2">2024</option>,
  <option key="3">2025</option>,
  <option key="4">2026</option>,
  <option key="5">2027</option>,
]

const getDaysInMonth = (month) => {
  const year = new Date().getFullYear();
  return new Date(year, month + 1, 0).getDate();
};

// Load Google Maps API dynamically
const loadGoogleMapsAPI = (setGoogleMapsLoaded) => {
  if (window.google && window.google.maps) {
    setGoogleMapsLoaded(true);
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    if (GOOGLE_MAPS_API_KEY === '') {
      toast.error('Google Maps API anahtarı gerekli.');
      reject(new Error('Google Maps API key required'));
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places,geometry&language=tr&region=TR`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      setGoogleMapsLoaded(true);
      resolve();
    };
    script.onerror = () => {
      toast.error('Google Maps API yüklenemedi.');
      reject(new Error('Failed to load Google Maps API'));
    };
    document.head.appendChild(script);
  });
};

// Decode Google Maps encoded polyline string
const decodePolyline = (encoded) => {
  if (!encoded) return [];

  const points = [];
  let index = 0;
  let lat = 0;
  let lng = 0;

  while (index < encoded.length) {
    let shift = 0;
    let result = 0;
    let byte;

    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);

    const dlat = (result & 1) ? ~(result >> 1) : (result >> 1);
    lat += dlat;

    shift = 0;
    result = 0;

    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);

    const dlng = (result & 1) ? ~(result >> 1) : (result >> 1);
    lng += dlng;

    points.push({
      lat: lat / 1e5,
      lng: lng / 1e5
    });
  }

  return points;
};

const ROUTE_COLORS = ['#14345c', '#e6194b', '#3cb44b', '#f58231', '#911eb4', '#42d4f4', '#f032e6', '#bfef45', '#fabed4', '#469990'];

const CustomerVehicleDetail = () => {
  const { id: vehicleId } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const routeId = queryParams.get('routeId');

  const [customerSummary, setCustomerSummary] = useState(null);
  const [currentVehicle, setCurrentVehicle] = useState(null);
  const [currentRoute, setCurrentRoute] = useState(null);
  const [currentProject, setCurrentProject] = useState(null);

  const [routes, setRoutes] = useState([]);

  const mapRef = useRef();
  const mapContainerRef = useRef();
  const { accessToken, setSasToken, setProgress, darkMode } = useContext(MainContext);

  // Google Maps services
  const directionsService = useRef(null);
  const clickTimeoutRef = useRef(null);

  // Google Maps state
  const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false);
  const [routePolylines, setRoutePolylines] = useState([]);
  const [routeMarkers, setRouteMarkers] = useState([]);

  // Walking route state
  const [isWalkingMode, setIsWalkingMode] = useState(false);
  const isWalkingModeRef = useRef(false);
  const [walkingPointA, setWalkingPointA] = useState(null);
  const [walkingPointB, setWalkingPointB] = useState(null);
  const walkingPointARef = useRef(null);
  const walkingPointBRef = useRef(null);
  const [walkingWaypoints, setWalkingWaypoints] = useState([]);
  const walkingWaypointsRef = useRef([]);
  const [walkingDistance, setWalkingDistance] = useState('');
  const [walkingDuration, setWalkingDuration] = useState('');
  const walkingRendererRef = useRef(null);
  const [walkingMarkers, setWalkingMarkers] = useState([]);
  const walkingWaypointMarkersData = useRef([]);

  // Driving route state
  const [isDrivingMode, setIsDrivingMode] = useState(false);
  const isDrivingModeRef = useRef(false);
  const [drivingPointA, setDrivingPointA] = useState(null);
  const [drivingPointB, setDrivingPointB] = useState(null);
  const drivingPointARef = useRef(null);
  const drivingPointBRef = useRef(null);
  const [drivingWaypoints, setDrivingWaypoints] = useState([]);
  const drivingWaypointsRef = useRef([]);
  const [drivingDistance, setDrivingDistance] = useState('');
  const [drivingDuration, setDrivingDuration] = useState('');
  const drivingRendererRef = useRef(null);
  const [drivingMarkers, setDrivingMarkers] = useState([]);
  const drivingWaypointMarkersData = useRef([]);

  // Distance measurement state
  const [isMeasurementMode, setIsMeasurementMode] = useState(false);
  const isMeasurementModeRef = useRef(false);
  const [measurementPoints, setMeasurementPoints] = useState([]);
  const measurementPointsRef = useRef([]);
  const [measurementMarkers, setMeasurementMarkers] = useState([]);
  const measurementMarkersRef = useRef([]);
  const [measurementPolyline, setMeasurementPolyline] = useState(null);
  const measurementPolylineRef = useRef(null);
  const [measurementDistance, setMeasurementDistance] = useState('');

  // Address search state
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [searchMarkers, setSearchMarkers] = useState([]);

  // Planned route polyline ref for cleanup
  const plannedRoutePolylineRef = useRef(null);
  const addPlannedRouteToMapRef = useRef(null); // ref to avoid stale closure in fetchStopList

  // Multi-select route state
  const [selectedRouteIds, setSelectedRouteIds] = useState(new Set());
  const selectedRouteIdsRef = useRef(new Set());
  const routePolylineMapRef = useRef({}); // routeId -> { polyline, color }
  const routeGpsMapRef = useRef({}); // routeId -> { polylines: [], markers: [], color }
  const routeStopMarkersMapRef = useRef({}); // compositeKey -> google.maps.Marker[]
  const lastStopMarkersRef = useRef({}); // "lat_lng" -> { marker, refCount } — shared last-stop markers
  const routeColorMapRef = useRef({}); // routeId -> stable color string
  const nextColorIndexRef = useRef(0); // monotonically increasing index into ROUTE_COLORS

  const getRouteKey = (route) => route._routeIdx != null
    ? `${route._id}_${route.vehicleId}_${route._routeIdx}`
    : route.vehicleId
      ? `${route._id}_${route.vehicleId}`
      : String(route._id);
  const searchTimeoutRef = useRef();
  const autocompleteService = useRef(null);
  const placesService = useRef(null);
  const activeInfoWindowRef = useRef(null);

  // Address search handlers
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (query.length < 3) {
      setSearchResults([]);
      setShowSearchResults(false);
      return;
    }

    searchTimeoutRef.current = setTimeout(() => {
      performSearch(query);
    }, 300);
  };

  const performSearch = async (query) => {
    if (!autocompleteService.current) return;

    try {
      const request = {
        input: query,
        componentRestrictions: { country: 'tr' },
        locationBias: {
          center: new window.google.maps.LatLng(41.032921, 29.032669),
          radius: 50000
        },
        types: ['geocode', 'establishment']
      };

      autocompleteService.current.getPlacePredictions(request, (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
          const formattedResults = predictions.slice(0, 5).map(prediction => ({
            place_name: prediction.description,
            place_id: prediction.place_id,
            center: null
          }));
          setSearchResults(formattedResults);
          setShowSearchResults(true);
        } else {
          setSearchResults([]);
          setShowSearchResults(false);
        }
      });
    } catch (error) {
      console.error('Search error:', error);
      toast.error('Arama yapılırken bir hata oluştu.');
    }
  };

  const handleSearchResultClick = (result) => {
    if (!placesService.current) return;

    const request = {
      placeId: result.place_id,
      fields: ['name', 'geometry', 'formatted_address']
    };

    placesService.current.getDetails(request, (place, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK && place.geometry) {
        const location = place.geometry.location;

        searchMarkers.forEach(marker => marker.setMap(null));

        const marker = new window.google.maps.Marker({
          position: location,
          map: mapRef.current,
          icon: {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: 15,
            fillColor: '#ff6b6b',
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 3
          }
        });

        marker.addListener('click', () => {
          // If a mode is active, forward click as a map click at this location
          if (isMeasurementModeRef.current || isWalkingModeRef.current || isDrivingModeRef.current) {
            window.google.maps.event.trigger(mapRef.current, 'click', { latLng: location });
          } else {
            if (activeInfoWindowRef.current) activeInfoWindowRef.current.close();
            const infoWindow = new window.google.maps.InfoWindow({
              content: `<h6>${place.name || result.place_name}</h6>`
            });
            infoWindow.open(mapRef.current, marker);
            activeInfoWindowRef.current = infoWindow;
          }
        });

        marker.addListener('dblclick', () => {
          if (isWalkingModeRef.current || isDrivingModeRef.current) {
            window.google.maps.event.trigger(mapRef.current, 'dblclick', { latLng: location });
          }
        });

        setSearchMarkers([marker]);

        mapRef.current.panTo(location);
        mapRef.current.setZoom(15);

        setShowSearchResults(false);
        setSearchQuery(result.place_name);
      }
    });
  };

  const clearSearch = () => {
    setSearchQuery('');
    setSearchResults([]);
    setShowSearchResults(false);

    searchMarkers.forEach(marker => marker.setMap(null));
    setSearchMarkers([]);
  };

  const fetchCustomerSummary = useCallback(async () => {
    try {
      const response = await apiService.getWithFirstResolve('customer/summary', accessToken, setProgress);
      const data = await response.json();
      if (data) {
        localStorage.setItem('customerSummary', JSON.stringify(data));
        return data;
      }
    } catch (error) {
      console.error('Error fetching customer summary:', error);
      toast.error('Müşteri verilerini getirirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.');
    }
    return null;
  }, [accessToken, setProgress]);

  useEffect(() => {
    const initializeData = async () => {
      let parsedCustomerSummary = null;
      const storedCustomerSummary = localStorage.getItem('customerSummary');

      if (storedCustomerSummary) {
        parsedCustomerSummary = JSON.parse(storedCustomerSummary);
      } else {
        parsedCustomerSummary = await fetchCustomerSummary();
      }

      if (parsedCustomerSummary) {
        setCustomerSummary(parsedCustomerSummary);

        let foundVehicle = null;
        let foundRoute = null;
        let projectRoutes = [];
        let projectCopy = {};
        for (const project of parsedCustomerSummary.projects) {
          const route = project.routes.find(r => r._id == routeId && r.vehicleId == vehicleId);
          if (route) {
            foundVehicle = parsedCustomerSummary.vehicles[vehicleId];
            // Stamp each route with a unique index so getRouteKey is always unique
            projectRoutes = project.routes.map((r, idx) => ({ ...r, _routeIdx: idx }));
            foundRoute = projectRoutes.find(r => r._id == routeId && r.vehicleId == vehicleId);
            projectCopy = project;
            break;
          }
        }

        if (foundVehicle && foundRoute) {
          setRoutes(projectRoutes);
          setCurrentRoute(foundRoute);
          const rid = getRouteKey(foundRoute);
          const initialSet = new Set([rid]);
          setSelectedRouteIds(initialSet);
          selectedRouteIdsRef.current = initialSet;
          // Assign stable color for the initial route
          if (!routeColorMapRef.current[rid]) {
            routeColorMapRef.current[rid] = ROUTE_COLORS[nextColorIndexRef.current % ROUTE_COLORS.length];
            nextColorIndexRef.current++;
          }
          setCurrentProject(projectCopy);
          setCurrentVehicle(foundVehicle);
        } else {
          console.error('Vehicle or route not found');
        }
      }
    };

    initializeData();
  }, [vehicleId, routeId, fetchCustomerSummary]);

  useEffect(() => {
    if (!accessToken)
      return;

    apiService.getWithFirstResolve('acquireSasTokenForDocs', accessToken, setProgress)
    .then(data => {
      setSasToken(data.headers.get('Sas-Token'));
      return data.json();
    })
    .then(data => (data));
  }, [])

  const [vehicleHistory, setVehicleHistory] = useState(null);
  const vehicleHistoryRef = useRef(null);
  const now = useMemo(() => new Date(), []);
  let yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);
  let twoDaysAgo = new Date();
  twoDaysAgo.setDate(now.getDate() - 2);
  let threeDaysAgo = new Date();
  threeDaysAgo.setDate(now.getDate() - 3);
  let fourDaysAgo = new Date();
  fourDaysAgo.setDate(now.getDate() - 4);

  let oneDayAfterFourDaysAgo = new Date();
  oneDayAfterFourDaysAgo.setDate(now.getDate() - 3);
  let oneDayAfterTwoDaysAgo = new Date();
  oneDayAfterTwoDaysAgo.setDate(now.getDate() - 1);

  const [startDate, setStartDate] = useState(now);
  const [startTime, setStartTime] = useState("00:00");
  const [finishDate, setFinishDate] = useState(now);
  const [finishTime, setFinishTime] = useState("23:59");

  const [showSidebar, setShowSidebar] = useState(false);

  const handleCloseSidebar = () => setShowSidebar(false);
  const handleShowSidebar = () => setShowSidebar(true);

  const markersRef = useRef([]);

  const [lastClickedIcon, setLastClickedIcon] = useState(null);
  const [leftPaneCollapsed, setLeftPaneCollapsed] = useState(false);
  const [routeInfoPopup, setRouteInfoPopup] = useState(null); // { routeId, top, left } or null
  const [gpsWarningPopup, setGpsWarningPopup] = useState(null); // { routeId, top, left } or null

  const [stopList, setStopList] = useState([]);
  const [plannedRoutePath, setPlannedRoutePath] = useState(null);
  const [routePathUpdatedAt, setRoutePathUpdatedAt] = useState(null);

  // Helper function to check if GPS URL is valid
  const hasValidGpsUrl = (vehicle) => {
    return vehicle?.gpsUrl &&
           vehicle.gpsUrl !== null &&
           vehicle.gpsUrl !== 'null' &&
           vehicle.gpsUrl !== undefined &&
           vehicle.gpsUrl !== 'undefined' &&
           vehicle.gpsUrl.trim() !== '';
  };

  const handleHistoryFilter = () => {
    if (hasValidGpsUrl(currentVehicle))
    {
      const threeYearsAgo = new Date();
      threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3);

      if (startDate === null || startDate === undefined) {
        alert("Başlangıç tarihi seçilmedi.");
        return;
      }

      if (finishDate === null || finishDate === undefined) {
        alert("Bitiş tarihi seçilmedi.");
        return;
      }
      if (startTime === null || startTime === undefined || startTime === "") {
        alert("Başlangıç saati seçilmedi.");
        return;
      }

      if (finishTime === null || finishTime === undefined || finishTime === "") {
        alert("Bitiş saati seçilmedi.");
        return;
      }

      if (new Date(startDate) < threeYearsAgo) {
        alert("Başlangıç tarihi 3 yıldan erken olamaz.");
        return;
      }

      fetchTravelHistory(currentVehicle.gpsUrl, startDate, startTime, finishDate, finishTime);
      refreshOtherRoutesGps(startDate, startTime, finishDate, finishTime);
      showSidebar && handleCloseSidebar();
    }
  }

  const handleDocForm = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (currentVehicle && currentVehicle["plate"]) {
      document.title = `${currentVehicle["plate"]}`;
    }
  }, [currentVehicle]);

  // ========================
  // Walking Route Functions
  // ========================
  const toggleWalkingRoute = () => {
    if (isWalkingMode) {
      clearWalkingRoute();
    } else {
      setIsDrivingMode(false);
      isDrivingModeRef.current = false;
      setIsMeasurementMode(false);
      isMeasurementModeRef.current = false;

      setIsWalkingMode(true);
      isWalkingModeRef.current = true;
    }
  };

  const clearWalkingRoute = () => {
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
      clickTimeoutRef.current = null;
    }

    setWalkingPointA(null);
    setWalkingPointB(null);
    setWalkingWaypoints([]);
    setWalkingDistance('');
    setWalkingDuration('');
    setIsWalkingMode(false);
    isWalkingModeRef.current = false;
    walkingPointARef.current = null;
    walkingPointBRef.current = null;
    walkingWaypointsRef.current = [];

    if (walkingRendererRef.current) {
      walkingRendererRef.current.setMap(null);
      walkingRendererRef.current = null;
    }

    walkingMarkers.forEach(marker => marker.setMap(null));
    setWalkingMarkers([]);

    walkingWaypointMarkersData.current.forEach(marker => {
      marker.setMap(null);
    });
    walkingWaypointMarkersData.current = [];
  };

  // ========================
  // Driving Route Functions
  // ========================
  const toggleDrivingRoute = () => {
    if (isDrivingMode) {
      clearDrivingRoute();
    } else {
      setIsWalkingMode(false);
      isWalkingModeRef.current = false;
      setIsMeasurementMode(false);
      isMeasurementModeRef.current = false;

      setIsDrivingMode(true);
      isDrivingModeRef.current = true;
    }
  };

  const clearDrivingRoute = () => {
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
      clickTimeoutRef.current = null;
    }

    setDrivingPointA(null);
    setDrivingPointB(null);
    setDrivingWaypoints([]);
    setDrivingDistance('');
    setDrivingDuration('');
    setIsDrivingMode(false);
    isDrivingModeRef.current = false;
    drivingPointARef.current = null;
    drivingPointBRef.current = null;
    drivingWaypointsRef.current = [];

    if (drivingRendererRef.current) {
      drivingRendererRef.current.setMap(null);
      drivingRendererRef.current = null;
    }

    drivingMarkers.forEach(marker => marker.setMap(null));
    setDrivingMarkers([]);

    drivingWaypointMarkersData.current.forEach(marker => {
      marker.setMap(null);
    });
    drivingWaypointMarkersData.current = [];
  };

  // ========================
  // Measurement Functions
  // ========================
  const toggleMeasurementMode = () => {
    if (isMeasurementMode) {
      clearMeasurement();
    } else {
      setIsWalkingMode(false);
      isWalkingModeRef.current = false;
      setIsDrivingMode(false);
      isDrivingModeRef.current = false;

      setIsMeasurementMode(true);
      isMeasurementModeRef.current = true;
    }
  };

  const clearMeasurement = () => {
    setMeasurementPoints([]);
    measurementPointsRef.current = [];
    setMeasurementDistance('');
    setIsMeasurementMode(false);
    isMeasurementModeRef.current = false;

    if (measurementPolylineRef.current) {
      measurementPolylineRef.current.setMap(null);
      measurementPolylineRef.current = null;
    }
    setMeasurementPolyline(null);

    measurementMarkersRef.current.forEach(marker => marker.setMap(null));
    measurementMarkersRef.current = [];
    setMeasurementMarkers([]);
  };

  const calculateMeasurementDistance = (points) => {
    if (!points || points.length < 2) {
      setMeasurementDistance('');
      return 0;
    }

    let totalDistance = 0;
    for (let i = 0; i < points.length - 1; i++) {
      const distance = window.google.maps.geometry.spherical.computeDistanceBetween(
        points[i],
        points[i + 1]
      );
      totalDistance += distance;
    }

    if (totalDistance < 1000) {
      setMeasurementDistance(totalDistance.toFixed(0) + ' m');
    } else {
      const distanceInKm = (totalDistance / 1000).toFixed(3);
      setMeasurementDistance(distanceInKm + ' km');
    }
    return totalDistance;
  };

  const updateMeasurementPolyline = (points) => {
    if (measurementPolylineRef.current) {
      measurementPolylineRef.current.setMap(null);
    }

    if (points.length < 2) {
      measurementPolylineRef.current = null;
      setMeasurementPolyline(null);
      return;
    }

    const polyline = new window.google.maps.Polyline({
      path: points,
      geodesic: true,
      strokeColor: '#FFA500',
      strokeOpacity: 1.0,
      strokeWeight: 4,
      icons: [{
        icon: {
          path: 'M 0,-1 0,1',
          strokeOpacity: 1,
          scale: 3
        },
        offset: '0',
        repeat: '20px'
      }]
    });

    polyline.setMap(mapRef.current);
    measurementPolylineRef.current = polyline;
    setMeasurementPolyline(polyline);
  };

  const recreateMeasurementMarkers = () => {
    measurementMarkersRef.current.forEach(marker => marker.setMap(null));
    measurementMarkersRef.current = [];

    measurementPointsRef.current.forEach((point, index) => {
      const marker = new window.google.maps.Marker({
        position: point,
        map: mapRef.current,
        label: {
          text: (index + 1).toString(),
          color: '#ffffff',
          fontSize: '12px',
          fontWeight: 'bold'
        },
        draggable: true,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 10,
          fillColor: '#FFA500',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2
        },
        zIndex: 2000
      });

      marker.addListener('dragend', (event) => {
        const newPosition = event.latLng;
        const updatedPoints = [...measurementPointsRef.current];
        updatedPoints[index] = newPosition;

        setMeasurementPoints(updatedPoints);
        measurementPointsRef.current = updatedPoints;

        updateMeasurementPolyline(updatedPoints);
        calculateMeasurementDistance(updatedPoints);
      });

      marker.addListener('rightclick', () => {
        const updatedPoints = measurementPointsRef.current.filter((_, i) => i !== index);
        setMeasurementPoints(updatedPoints);
        measurementPointsRef.current = updatedPoints;

        recreateMeasurementMarkers();
        updateMeasurementPolyline(updatedPoints);
        calculateMeasurementDistance(updatedPoints);
      });

      measurementMarkersRef.current.push(marker);
    });

    setMeasurementMarkers(measurementMarkersRef.current);
  };

  const handleMeasurementMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    const clickedPoint = new window.google.maps.LatLng(lat, lng);

    const newPoints = [...measurementPointsRef.current, clickedPoint];
    setMeasurementPoints(newPoints);
    measurementPointsRef.current = newPoints;

    recreateMeasurementMarkers();
    updateMeasurementPolyline(newPoints);
    calculateMeasurementDistance(newPoints);
  };

  // ========================
  // Route Directions (shared between walking & driving)
  // ========================
  const calculateRouteDirections = (pointA, pointB, waypoints = [], mode = 'WALKING') => {
    if (!directionsService.current || !pointA || !pointB) {
      console.error('Missing requirements for directions calculation');
      return;
    }

    const isWalking = mode === 'WALKING';
    const routeColor = isWalking ? '#008000' : '#9932CC';
    const rendererRef = isWalking ? walkingRendererRef : drivingRendererRef;
    const setDistance = isWalking ? setWalkingDistance : setDrivingDistance;
    const setDuration = isWalking ? setWalkingDuration : setDrivingDuration;
    const travelMode = isWalking ? window.google.maps.TravelMode.WALKING : window.google.maps.TravelMode.DRIVING;

    const googleWaypoints = waypoints.map(wp => ({
      location: wp,
      stopover: true
    }));

    const request = {
      origin: pointA,
      destination: pointB,
      waypoints: googleWaypoints,
      travelMode: travelMode
    };

    directionsService.current.route(request, (result, status) => {
      if (status === window.google.maps.DirectionsStatus.OK) {
        const route = result.routes[0];
        let totalDistanceMeters = 0;
        let totalDurationSeconds = 0;

        route.legs.forEach(leg => {
          totalDistanceMeters += leg.distance.value;
          totalDurationSeconds += leg.duration.value;
        });

        const totalDistanceKm = (totalDistanceMeters / 1000).toFixed(2);
        const totalDistanceText = totalDistanceKm + ' km';

        const hours = Math.floor(totalDurationSeconds / 3600);
        const minutes = Math.floor((totalDurationSeconds % 3600) / 60);
        let totalDurationText = '';
        if (hours > 0) {
          totalDurationText = `${hours} saat ${minutes} dakika`;
        } else {
          totalDurationText = `${minutes} dakika`;
        }

        setDistance(totalDistanceText);
        setDuration(totalDurationText);

        let isNewRenderer = false;
        if (!rendererRef.current) {
          rendererRef.current = new window.google.maps.DirectionsRenderer({
            polylineOptions: {
              strokeColor: routeColor,
              strokeWeight: 7,
              strokeOpacity: 1,
              geodesic: true
            },
            suppressMarkers: true,
            preserveViewport: true
          });
          rendererRef.current.setMap(mapRef.current);
          isNewRenderer = true;
        } else {
          rendererRef.current.setMap(null);
        }

        rendererRef.current.setDirections(result);

        if (!isNewRenderer) {
          rendererRef.current.setMap(mapRef.current);
        }
      } else {
        console.error('Directions API error:', status);
        toast.error('Rota hesaplanamadı: ' + status);
      }
    });
  };

  // Walking waypoint helpers
  const getWalkingWaypointsFromMarkers = () => {
    return walkingWaypointMarkersData.current.map(marker => marker.getPosition());
  };

  const getDrivingWaypointsFromMarkers = () => {
    return drivingWaypointMarkersData.current.map(marker => marker.getPosition());
  };

  const recreateWalkingWaypointMarkers = () => {
    walkingWaypointMarkersData.current.forEach(marker => {
      marker.setMap(null);
    });
    walkingWaypointMarkersData.current = [];

    walkingWaypointsRef.current.forEach((waypoint, index) => {
      const marker = new window.google.maps.Marker({
        position: waypoint,
        map: mapRef.current,
        label: (index + 1).toString(),
        draggable: true,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 10,
          fillColor: '#FFA500',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2
        }
      });

      walkingWaypointMarkersData.current.push(marker);

      marker.addListener('dragend', (event) => {
        const currentWaypoints = getWalkingWaypointsFromMarkers();
        setWalkingWaypoints(currentWaypoints);
        walkingWaypointsRef.current = currentWaypoints;

        if (walkingPointBRef.current) {
          calculateRouteDirections(walkingPointARef.current, walkingPointBRef.current, currentWaypoints, 'WALKING');
        }
      });
    });
  };

  const recreateDrivingWaypointMarkers = () => {
    drivingWaypointMarkersData.current.forEach(marker => {
      marker.setMap(null);
    });
    drivingWaypointMarkersData.current = [];

    drivingWaypointsRef.current.forEach((waypoint, index) => {
      const marker = new window.google.maps.Marker({
        position: waypoint,
        map: mapRef.current,
        label: (index + 1).toString(),
        draggable: true,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 10,
          fillColor: '#FFA500',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2
        }
      });

      drivingWaypointMarkersData.current.push(marker);

      marker.addListener('dragend', (event) => {
        const currentWaypoints = getDrivingWaypointsFromMarkers();
        setDrivingWaypoints(currentWaypoints);
        drivingWaypointsRef.current = currentWaypoints;

        if (drivingPointBRef.current) {
          calculateRouteDirections(drivingPointARef.current, drivingPointBRef.current, currentWaypoints, 'DRIVING');
        }
      });
    });
  };

  // Walking map click handler
  const handleWalkingMapClick = (e) => {
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
    }

    clickTimeoutRef.current = setTimeout(() => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      const clickedPoint = new window.google.maps.LatLng(lat, lng);

      if (!walkingPointARef.current) {
        setWalkingPointA(clickedPoint);
        walkingPointARef.current = clickedPoint;

        const markerA = new window.google.maps.Marker({
          position: clickedPoint,
          map: mapRef.current,
          label: 'A',
          draggable: true,
          icon: {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: 10,
            fillColor: '#4CAF50',
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 2
          }
        });

        markerA.addListener('dragend', (event) => {
          const newPosition = event.latLng;
          setWalkingPointA(newPosition);
          walkingPointARef.current = newPosition;

          if (walkingPointBRef.current) {
            calculateRouteDirections(newPosition, walkingPointBRef.current, walkingWaypointsRef.current, 'WALKING');
          }
        });

        setWalkingMarkers([markerA]);

      } else if (walkingPointBRef.current) {
        // Route is complete
      } else {
        const newWaypoints = [...walkingWaypointsRef.current, clickedPoint];
        setWalkingWaypoints(newWaypoints);
        walkingWaypointsRef.current = newWaypoints;

        recreateWalkingWaypointMarkers();
      }
    }, 150);
  };

  const handleWalkingMapDoubleClick = (e) => {
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
      clickTimeoutRef.current = null;
    }

    if (!walkingPointARef.current) {
      return;
    }

    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    const clickedPoint = new window.google.maps.LatLng(lat, lng);

    setWalkingPointB(clickedPoint);
    walkingPointBRef.current = clickedPoint;

    const markerB = new window.google.maps.Marker({
      position: clickedPoint,
      map: mapRef.current,
      label: 'B',
      draggable: true,
      icon: {
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: 10,
        fillColor: '#f44336',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 2
      }
    });

    markerB.addListener('dragend', (event) => {
      const newPosition = event.latLng;
      setWalkingPointB(newPosition);
      walkingPointBRef.current = newPosition;

      calculateRouteDirections(walkingPointARef.current, newPosition, walkingWaypointsRef.current, 'WALKING');
    });

    setWalkingMarkers(prev => [...prev, markerB]);
    calculateRouteDirections(walkingPointARef.current, clickedPoint, walkingWaypointsRef.current, 'WALKING');
  };

  // Driving map click handler
  const handleDrivingMapClick = (e) => {
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
    }

    clickTimeoutRef.current = setTimeout(() => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      const clickedPoint = new window.google.maps.LatLng(lat, lng);

      if (!drivingPointARef.current) {
        setDrivingPointA(clickedPoint);
        drivingPointARef.current = clickedPoint;

        const markerA = new window.google.maps.Marker({
          position: clickedPoint,
          map: mapRef.current,
          label: 'A',
          draggable: true,
          icon: {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: 10,
            fillColor: '#4CAF50',
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 2
          }
        });

        markerA.addListener('dragend', (event) => {
          const newPosition = event.latLng;
          setDrivingPointA(newPosition);
          drivingPointARef.current = newPosition;

          if (drivingPointBRef.current) {
            calculateRouteDirections(newPosition, drivingPointBRef.current, drivingWaypointsRef.current, 'DRIVING');
          }
        });

        setDrivingMarkers([markerA]);

      } else if (drivingPointBRef.current) {
        // Route is complete
      } else {
        const newWaypoints = [...drivingWaypointsRef.current, clickedPoint];
        setDrivingWaypoints(newWaypoints);
        drivingWaypointsRef.current = newWaypoints;

        recreateDrivingWaypointMarkers();
      }
    }, 150);
  };

  const handleDrivingMapDoubleClick = (e) => {
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
      clickTimeoutRef.current = null;
    }

    if (!drivingPointARef.current) {
      return;
    }

    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    const clickedPoint = new window.google.maps.LatLng(lat, lng);

    setDrivingPointB(clickedPoint);
    drivingPointBRef.current = clickedPoint;

    const markerB = new window.google.maps.Marker({
      position: clickedPoint,
      map: mapRef.current,
      label: 'B',
      draggable: true,
      icon: {
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: 10,
        fillColor: '#f44336',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 2
      }
    });

    markerB.addListener('dragend', (event) => {
      const newPosition = event.latLng;
      setDrivingPointB(newPosition);
      drivingPointBRef.current = newPosition;

      calculateRouteDirections(drivingPointARef.current, newPosition, drivingWaypointsRef.current, 'DRIVING');
    });

    setDrivingMarkers(prev => [...prev, markerB]);
    calculateRouteDirections(drivingPointARef.current, clickedPoint, drivingWaypointsRef.current, 'DRIVING');
  };

  // Main map click handler
  const handleMapClick = (e) => {
    if (isMeasurementModeRef.current) {
      handleMeasurementMapClick(e);
    } else if (isWalkingModeRef.current) {
      handleWalkingMapClick(e);
    } else if (isDrivingModeRef.current) {
      handleDrivingMapClick(e);
    }
  };

  const handleMapDoubleClick = (e) => {
    if (isWalkingModeRef.current) {
      handleWalkingMapDoubleClick(e);
    } else if (isDrivingModeRef.current) {
      handleDrivingMapDoubleClick(e);
    }
  };

  // ========================
  // Map Initialization (Google Maps)
  // ========================
  const initializeMap = async () => {
    try {
      await loadGoogleMapsAPI(setGoogleMapsLoaded);

      if (!mapRef.current && mapContainerRef.current) {
        const mapOptions = {
          center: { lat: 41.032921, lng: 29.032669 },
          zoom: 10,
          mapTypeId: 'roadmap',
          mapTypeControlOptions: {
            position: window.google.maps.ControlPosition.RIGHT_BOTTOM
          },
          streetViewControlOptions: {
            position: window.google.maps.ControlPosition.RIGHT_BOTTOM
          },
          fullscreenControlOptions: {
            position: window.google.maps.ControlPosition.RIGHT_BOTTOM
          }
        };

        mapRef.current = new window.google.maps.Map(mapContainerRef.current, mapOptions);

        directionsService.current = new window.google.maps.DirectionsService();
        autocompleteService.current = new window.google.maps.places.AutocompleteService();
        placesService.current = new window.google.maps.places.PlacesService(mapRef.current);

        // Add click/dblclick listeners for measurement/walking/driving modes
        mapRef.current.addListener('click', handleMapClick);
        mapRef.current.addListener('dblclick', handleMapDoubleClick);

        addLegend();

        if (vehicleHistory?.length > 0) {
          addRouteAndDot();
        }
      }
    } catch (error) {
      console.error('Failed to initialize map:', error);
    }
  };

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.setMapTypeId(darkMode ? 'hybrid' : 'roadmap');
    }
  }, [darkMode]);

  const addLegend = () => {
    const existingLegend = document.querySelector('.map-legend');
    if (existingLegend) return;

    if (!mapContainerRef.current) return;

    const legend = document.createElement('div');
    legend.className = 'map-legend';
    legend.innerHTML = `
      <div style="
        padding: 10px;
        background-color: rgba(0, 0, 0, 0.9);
        color: #5a9bd4;
        border: 2px solid rgba(20, 52, 92, 0.4);
        border-radius: 10px;
        position: absolute;
        bottom: 10px;
        left: 10px;
        z-index: 1;
        font-size: 12px;
        line-height: 20px;
        display: flex;
        gap: 0;
      ">
        <div style="display: grid; grid-template-columns: auto 1fr; gap: 5px 10px;">
          <div style="display: flex; align-items: center;">
            <svg width="16" height="16" viewBox="0 0 40 40" style="vertical-align: middle;">
              <circle cx="20" cy="20" r="18" fill="#4CAF50" stroke="#ffffff" stroke-width="2"/>
              <polygon points="14,10 30,20 14,30" fill="#ffffff"/>
            </svg>
          </div>
          <div>Başlangıç</div>
          <div style="display: flex; align-items: center;"><span style="background-color: #FFA500; opacity: 0.6; width: 8px; height: 8px; display: inline-block; border-radius: 50%;"></span></div>
          <div>Duruş</div>
          <div style="display: flex; align-items: center;"><span style="background-color: #3151f5; width: 20px; height: 4px; display: inline-block;"></span></div>
          <div>Gerçek Rota</div>
          <div style="display: flex; align-items: center;">
            <svg width="16" height="16" viewBox="0 0 40 40" style="vertical-align: middle;">
              <circle cx="20" cy="20" r="18" fill="#ff0000" stroke="#ffffff" stroke-width="2"/>
              <text x="20" y="28" font-family="Arial" font-size="24" fill="#ffffff" text-anchor="middle">X</text>
            </svg>
          </div>
          <div>Bitiş</div>
          <div style="display: flex; align-items: center;">
            <svg width="20" height="4" style="vertical-align: middle;">
              <line x1="0" y1="2" x2="20" y2="2" stroke="#14345c" stroke-width="4" stroke-dasharray="2,2"/>
            </svg>
          </div>
          <div>Planlanan Rota</div>
        </div>
        <div style="width: 1px; background: rgba(90,155,212,0.3); margin: 0 12px; align-self: stretch;"></div>
        <div style="display: grid; grid-template-columns: auto 1fr; gap: 5px 10px;">
          <div style="display: flex; align-items: center;"><span style="background-color: #008000; width: 20px; height: 4px; display: inline-block;"></span></div>
          <div>Yürüyüş Rotası</div>
          <div style="display: flex; align-items: center;"><span style="background-color: #9932CC; width: 20px; height: 4px; display: inline-block;"></span></div>
          <div>Araç Rotası</div>
          <div style="display: flex; align-items: center;">
            <svg width="20" height="4" style="vertical-align: middle;">
              <line x1="0" y1="2" x2="20" y2="2" stroke="#FFA500" stroke-width="4" stroke-dasharray="4,4"/>
            </svg>
          </div>
          <div>Ölçüm</div>
          <div style="display: flex; align-items: center;"><span style="background-color: #ff6b6b; width: 10px; height: 10px; display: inline-block; border-radius: 50%; border: 1.5px solid #ffffff;"></span></div>
          <div>Adres Arama</div>
        </div>
      </div>
    `;
    mapContainerRef.current.appendChild(legend);
  };

  // Helper function to calculate idle time between points
  const calculateIdleTime = (startIndex, endIndex) => {
    if (!vehicleHistory || startIndex >= endIndex) return { minutes: 0, seconds: 0, display: '0s', totalMs: 0 };

    const startTimeVal = new Date(vehicleHistory[startIndex].ts);
    const endTime = new Date(vehicleHistory[endIndex].ts);
    const idleMs = endTime - startTimeVal;
    const minutes = Math.floor(idleMs / 60000);
    const seconds = Math.floor((idleMs % 60000) / 1000);

    let display = '';
    if (minutes > 0) {
      display = `${minutes}d ${seconds}s`;
    } else {
      display = `${seconds}s`;
    }

    return { minutes, seconds, display, totalMs: idleMs };
  };

  // Cleanup all Google Maps elements
  const cleanupMapElements = () => {
    try {
      if (routePolylines && Array.isArray(routePolylines)) {
        routePolylines.forEach((polyline) => {
          try {
            if (polyline && typeof polyline.setMap === 'function') {
              polyline.setMap(null);
            }
          } catch (e) {
            console.error('Error removing polyline:', e);
          }
        });
      }

      if (routeMarkers && Array.isArray(routeMarkers)) {
        routeMarkers.forEach((marker) => {
          try {
            if (marker && typeof marker.setMap === 'function') {
              marker.setMap(null);
            }
          } catch (e) {
            console.error('Error removing route marker:', e);
          }
        });
      }

      // Clear planned route polyline
      if (plannedRoutePolylineRef.current) {
        try {
          plannedRoutePolylineRef.current.setMap(null);
          plannedRoutePolylineRef.current = null;
        } catch (e) {
          console.error('Error removing planned route polyline:', e);
        }
      }

      // Clear all multi-route polylines
      Object.values(routePolylineMapRef.current).forEach(({ polyline }) => {
        try {
          if (polyline && typeof polyline.setMap === 'function') polyline.setMap(null);
        } catch (e) {
          console.error('Error removing multi-route polyline:', e);
        }
      });
      routePolylineMapRef.current = {};

      // Clear all multi-route GPS polylines/markers
      Object.values(routeGpsMapRef.current).forEach(({ polylines, markers }) => {
        polylines.forEach(p => { try { if (p && typeof p.setMap === 'function') p.setMap(null); } catch(e) {} });
        markers.forEach(m => { try { if (m && typeof m.setMap === 'function') m.setMap(null); } catch(e) {} });
      });
      routeGpsMapRef.current = {};

      // Clear all stashed stop markers
      Object.values(routeStopMarkersMapRef.current).forEach(entries => {
        entries.forEach(entry => removeStopMarkerEntry(entry));
      });
      routeStopMarkersMapRef.current = {};

      // Clear any remaining shared last-stop markers
      Object.values(lastStopMarkersRef.current).forEach(({ marker }) => {
        try { if (marker && typeof marker.setMap === 'function') marker.setMap(null); } catch(e) {}
      });
      lastStopMarkersRef.current = {};

      routeColorMapRef.current = {};
      nextColorIndexRef.current = 0;

      selectedRouteIdsRef.current = new Set();
      setSelectedRouteIds(new Set());

      setRoutePolylines([]);
      setRouteMarkers([]);
    } catch (error) {
      console.error('Error during cleanup:', error);
    }
  };

  // Stable color assignment: each route gets a permanent color when first selected
  const getOrAssignRouteColor = (routeId) => {
    const rid = String(routeId);
    if (!routeColorMapRef.current[rid]) {
      routeColorMapRef.current[rid] = ROUTE_COLORS[nextColorIndexRef.current % ROUTE_COLORS.length];
      nextColorIndexRef.current++;
    }
    return routeColorMapRef.current[rid];
  };

  const addRouteAndDot = () => {
    if (!mapRef.current || !vehicleHistory?.length) return;

    const coordinates = vehicleHistory.map(entry => [entry?.location?.lon, entry?.location?.lat]);
    const rid = currentRoute ? getRouteKey(currentRoute) : null;
    const gpsColor = rid ? getOrAssignRouteColor(rid) : '#3151f5';
    updateRouteAndDot(coordinates, gpsColor, rid);
  };

  const updateRouteAndDot = (coordinates, gpsColor = '#3151f5', routeId = null) => {
    try {
      // Clean up THIS route's old GPS from routeGpsMapRef (if it exists)
      if (routeId && routeGpsMapRef.current[routeId]) {
        routeGpsMapRef.current[routeId].polylines.forEach(p => { try { p.setMap(null); } catch(e) {} });
        routeGpsMapRef.current[routeId].markers.forEach(m => { try { m.setMap(null); } catch(e) {} });
        delete routeGpsMapRef.current[routeId];
      }
      // Clean up state polylines — but skip if they're stashed in routeGpsMapRef (another route owns them)
      const stashedPolylines = new Set();
      Object.values(routeGpsMapRef.current).forEach(({ polylines, markers }) => {
        polylines.forEach(p => stashedPolylines.add(p));
        markers.forEach(m => stashedPolylines.add(m));
      });
      if (routePolylines && Array.isArray(routePolylines)) {
        routePolylines.forEach((polyline) => {
          if (!stashedPolylines.has(polyline)) {
            try { if (polyline && typeof polyline.setMap === 'function') polyline.setMap(null); } catch (e) {}
          }
        });
      }
      if (routeMarkers && Array.isArray(routeMarkers)) {
        routeMarkers.forEach((marker) => {
          if (!stashedPolylines.has(marker)) {
            try { if (marker && typeof marker.setMap === 'function') marker.setMap(null); } catch (e) {}
          }
        });
      }
      setRoutePolylines([]);
      setRouteMarkers([]);

      const newPolylines = [];
      const newMarkers = [];

      // Create a continuous route line with all points
      const allPath = vehicleHistory.map(entry => ({
        lat: entry.location.lat,
        lng: entry.location.lon
      }));

      // Create main route polyline with directional arrows
      const arrowSymbol = {
        path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        scale: 3,
        strokeColor: '#ffffff',
        strokeWeight: 1,
        fillColor: gpsColor,
        fillOpacity: 1
      };

      if (allPath.length > 1) {
        const mainPolyline = new window.google.maps.Polyline({
          path: allPath,
          geodesic: true,
          strokeColor: gpsColor,
          strokeOpacity: 1.0,
          strokeWeight: 5,
          clickable: true,
          icons: [{
            icon: arrowSymbol,
            offset: '0',
            repeat: '100px'
          }]
        });

        mainPolyline.addListener('mouseover', () => {
          mapRef.current.getDiv().style.cursor = 'pointer';
        });

        mainPolyline.addListener('mouseout', () => {
          mapRef.current.getDiv().style.cursor = '';
        });

        // Click on route shows time at that point
        mainPolyline.addListener('click', (event) => {
          const currentVehicleHistory = vehicleHistoryRef.current;
          if (!currentVehicleHistory || currentVehicleHistory.length === 0) return;

          let closestPoint = null;
          let minDistance = Infinity;

          currentVehicleHistory.forEach((entry) => {
            const distance = window.google.maps.geometry.spherical.computeDistanceBetween(
              event.latLng,
              new window.google.maps.LatLng(entry.location.lat, entry.location.lon)
            );

            if (distance < minDistance) {
              minDistance = distance;
              closestPoint = entry;
            }
          });

          if (closestPoint) {
            const date = new Date(closestPoint.ts);
            const infoWindow = new window.google.maps.InfoWindow({
              content: `
                <div style="font-family: Arial, sans-serif; font-size: 13px; padding: 10px; min-width: 220px; background: #000; color: #fff;">
                  <h4 style="margin: 5px 0; color: #5a9bd4; font-size: 14px;">📍 Rota Noktası</h4>
                  <div style="background-color: rgba(20, 52, 92, 0.1); border: 1px solid rgba(20, 52, 92, 0.3); padding: 8px; border-radius: 5px; margin: 8px 0;">
                    <p style="margin: 3px 0; font-size: 14px; color: #5a9bd4;"><strong>Geçiş Zamanı</strong></p>
                    <p style="margin: 5px 0; font-size: 16px; color: #1e5a8a; font-weight: bold;">
                      ${date.toLocaleTimeString('tr-TR')}
                    </p>
                    <p style="margin: 3px 0; color: #aaa; font-size: 12px;">
                      ${date.toLocaleDateString('tr-TR')}
                    </p>
                  </div>
                  <p style="margin: 5px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Hız:</strong> <span>${closestPoint.speed || 0} km/h</span></p>
                </div>
              `,
              position: event.latLng
            });

            if (activeInfoWindowRef.current) activeInfoWindowRef.current.close();
            infoWindow.open(mapRef.current);
            activeInfoWindowRef.current = infoWindow;
          }
        });

        mainPolyline.setMap(mapRef.current);
        newPolylines.push(mainPolyline);
      }

      // Add start marker (green)
      if (vehicleHistory.length > 0) {
        const startEntry = vehicleHistory[0];
        const startTime = new Date(startEntry.ts);
        const startMarker = new window.google.maps.Marker({
          position: {
            lat: startEntry.location.lat,
            lng: startEntry.location.lon
          },
          map: mapRef.current,
          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                <circle cx="20" cy="20" r="18" fill="#4CAF50" stroke="#ffffff" stroke-width="2"/>
                <polygon points="14,10 30,20 14,30" fill="#ffffff"/>
              </svg>
            `),
            scaledSize: new window.google.maps.Size(20, 20)
          },
          title: 'Başlangıç Noktası',
          zIndex: 1000
        });
        const startInfoWindow = new window.google.maps.InfoWindow({
          content: `
            <div style="font-family: Arial, sans-serif; font-size: 12px; background: #000; color: #fff; padding: 10px; min-width: 200px;">
              <div style="display: flex; align-items: center; margin-bottom: 8px;">
                <span style="font-size: 16px; margin-right: 6px;">▶️</span>
                <h4 style="margin: 0; color: #4CAF50; font-size: 14px;">Başlangıç Noktası</h4>
              </div>
              <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Saat:</strong> <span>${startTime.toLocaleTimeString('tr-TR')}</span></p>
              <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Tarih:</strong> <span>${startTime.toLocaleDateString('tr-TR')}</span></p>
              <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Hız:</strong> <span>${startEntry.speed || 0} km/h</span></p>
              <p style="margin: 3px 0; font-size: 10px; color: #aaa; display: flex; justify-content: space-between;">
                <span>Koordinat:</span> <span>${startEntry.location.lon.toFixed(6)}, ${startEntry.location.lat.toFixed(6)}</span>
              </p>
            </div>
          `
        });
        startMarker.addListener('click', () => {
          if (activeInfoWindowRef.current) activeInfoWindowRef.current.close();
          startInfoWindow.open(mapRef.current, startMarker);
          activeInfoWindowRef.current = startInfoWindow;
        });
        newMarkers.push(startMarker);
      }

      // Add stop markers with idle time labels (red dots)
      vehicleHistory.forEach((entry, index) => {
        if (index > 0 && entry.speed === 0 && vehicleHistory[index - 1].speed > 0) {
          let stopEndIndex = index;
          while (stopEndIndex < vehicleHistory.length - 1 && vehicleHistory[stopEndIndex].speed === 0) {
            stopEndIndex++;
          }

          const idleTime = calculateIdleTime(index, stopEndIndex);

          if (idleTime.totalMs > 0) {
            const stopMarker = new window.google.maps.Marker({
              position: { lat: entry.location.lat, lng: entry.location.lon },
              map: mapRef.current,
              icon: {
                path: window.google.maps.SymbolPath.CIRCLE,
                scale: 6,
                fillColor: '#FFA500',
                fillOpacity: 0.6,
                strokeColor: '#ffffff',
                strokeWeight: 1.5
              },
              zIndex: 999
            });

            // Add info window with stop details (shown on click)
            const stopStartTime = new Date(entry.ts);
            const stopEndTime = new Date(vehicleHistory[stopEndIndex].ts);
            const infoWindow = new window.google.maps.InfoWindow({
              content: `
                <div style="font-family: Arial, sans-serif; font-size: 12px; background: #000; color: #fff; padding: 10px; min-width: 200px;">
                  <div style="display: flex; align-items: center; margin-bottom: 8px; padding-right: 20px;">
                    <span style="font-size: 16px; margin-right: 6px;">🛑</span>
                    <h4 style="margin: 0; color: #5a9bd4; font-size: 14px; white-space: nowrap;">Durak Noktası</h4>
                  </div>
                  <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Bekleme Süresi:</strong> <span>${idleTime.display}</span></p>
                  <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Başlangıç:</strong> <span>${stopStartTime.toLocaleTimeString('tr-TR')}</span></p>
                  <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Bitiş:</strong> <span>${stopEndTime.toLocaleTimeString('tr-TR')}</span></p>
                  <p style="margin: 3px 0; font-size: 10px; color: #aaa; display: flex; justify-content: space-between;">
                    <span>Koordinat:</span> <span>${entry.location.lon.toFixed(6)}, ${entry.location.lat.toFixed(6)}</span>
                  </p>
                </div>
              `
            });

            stopMarker.addListener('click', () => {
              if (activeInfoWindowRef.current) activeInfoWindowRef.current.close();
              infoWindow.open(mapRef.current, stopMarker);
              activeInfoWindowRef.current = infoWindow;
            });

            newMarkers.push(stopMarker);
          }
        }
      });

      // Add additional start markers after significant stops
      vehicleHistory.forEach((entry, index) => {
        if (index > 0 && entry.speed > 0 && vehicleHistory[index - 1].speed === 0) {
          // Check if the stop had significant wait time
          let stopStartIndex = index - 1;
          while (stopStartIndex > 0 && vehicleHistory[stopStartIndex].speed === 0) {
            stopStartIndex--;
          }
          stopStartIndex++;

          const idleTime = calculateIdleTime(stopStartIndex, index);
          if (idleTime.totalMs > 0) {
            const startMarker = new window.google.maps.Marker({
              position: { lat: entry.location.lat, lng: entry.location.lon },
              map: mapRef.current,
              icon: {
                path: window.google.maps.SymbolPath.CIRCLE,
                scale: 5,
                fillColor: '#4CAF50',
                fillOpacity: 1,
                strokeColor: '#ffffff',
                strokeWeight: 2
              },
              zIndex: 998
            });
            newMarkers.push(startMarker);
          }
        }
      });

      // Add end marker
      const lastEntry = vehicleHistory[vehicleHistory.length - 1];
      if (lastEntry) {
        const endTime = new Date(lastEntry.ts);
        const endMarker = new window.google.maps.Marker({
          position: { lat: lastEntry.location.lat, lng: lastEntry.location.lon },
          map: mapRef.current,
          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                <circle cx="20" cy="20" r="18" fill="#ff0000" stroke="#ffffff" stroke-width="2"/>
                <text x="20" y="28" font-family="Arial" font-size="24" fill="#ffffff" text-anchor="middle">X</text>
              </svg>
            `),
            scaledSize: new window.google.maps.Size(20, 20)
          }
        });
        const endInfoWindow = new window.google.maps.InfoWindow({
          content: `
            <div style="font-family: Arial, sans-serif; font-size: 12px; background: #000; color: #fff; padding: 10px; min-width: 200px;">
              <div style="display: flex; align-items: center; margin-bottom: 8px;">
                <span style="font-size: 16px; margin-right: 6px;">🏁</span>
                <h4 style="margin: 0; color: #ff0000; font-size: 14px;">Bitiş Noktası</h4>
              </div>
              <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Saat:</strong> <span>${endTime.toLocaleTimeString('tr-TR')}</span></p>
              <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Tarih:</strong> <span>${endTime.toLocaleDateString('tr-TR')}</span></p>
              <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Hız:</strong> <span>${lastEntry.speed || 0} km/h</span></p>
              <p style="margin: 3px 0; font-size: 10px; color: #aaa; display: flex; justify-content: space-between;">
                <span>Koordinat:</span> <span>${lastEntry.location.lon.toFixed(6)}, ${lastEntry.location.lat.toFixed(6)}</span>
              </p>
            </div>
          `
        });
        endMarker.addListener('click', () => {
          if (activeInfoWindowRef.current) activeInfoWindowRef.current.close();
          endInfoWindow.open(mapRef.current, endMarker);
          activeInfoWindowRef.current = endInfoWindow;
        });
        newMarkers.push(endMarker);
      }

      setRoutePolylines(newPolylines);
      setRouteMarkers(newMarkers);

      // Store in per-route GPS map for multi-select persistence
      if (routeId) {
        routeGpsMapRef.current[routeId] = { polylines: newPolylines, markers: newMarkers, color: gpsColor };
      }
    } catch (error) {
      console.error('Error updating route:', error);
    }
  };

  useEffect(() => {
    initializeMap();
  }, []);

  useEffect(() => {
    if (mapRef.current && vehicleHistory?.length > 0) {
      addRouteAndDot();
    }
  }, [vehicleHistory]);

  // Sync vehicleHistory ref whenever vehicleHistory state changes
  useEffect(() => {
    vehicleHistoryRef.current = vehicleHistory;
  }, [vehicleHistory]);

  // Function to decode and render planned route path (pure creator — no cleanup, no ref mutation)
  const addPlannedRouteToMap = (encodedPolyline, color = '#14345c') => {
    if (!mapRef.current || !encodedPolyline || !window.google) return null;

    try {
      const pathCoordinates = decodePolyline(encodedPolyline);

      if (pathCoordinates.length >= 2) {
        const plannedPolyline = new window.google.maps.Polyline({
          path: pathCoordinates,
          geodesic: true,
          strokeColor: color,
          strokeOpacity: 0,
          strokeWeight: 4,
          icons: [{
            icon: {
              path: 'M 0,-1 0,1',
              strokeOpacity: 1,
              strokeColor: color,
              scale: 3
            },
            offset: '0',
            repeat: '15px'
          }]
        });

        plannedPolyline.setMap(mapRef.current);
        return plannedPolyline;
      }
    } catch (error) {
      console.error('Error adding planned route to map:', error);
    }
    return null;
  };
  addPlannedRouteToMapRef.current = addPlannedRouteToMap;

  // Function to zoom map to fit travel history, planned route, and stop list
  const zoomToBothRoutes = () => {
    if (!mapRef.current) return;

    const bounds = new window.google.maps.LatLngBounds();
    let hasBounds = false;

    // Add travel history coordinates
    if (vehicleHistory?.length > 0) {
      vehicleHistory.forEach(entry => {
        bounds.extend(new window.google.maps.LatLng(entry.location.lat, entry.location.lon));
        hasBounds = true;
      });
    }

    // Add planned route coordinates
    if (plannedRoutePolylineRef.current) {
      const path = plannedRoutePolylineRef.current.getPath();
      if (path) {
        path.forEach(point => {
          bounds.extend(point);
          hasBounds = true;
        });
      }
    }

    // Add all multi-route planned polylines to bounds
    Object.values(routePolylineMapRef.current).forEach(({ polyline }) => {
      try {
        const path = polyline.getPath();
        if (path) {
          path.forEach(point => {
            bounds.extend(point);
            hasBounds = true;
          });
        }
      } catch (e) {}
    });

    // Add all multi-route GPS polylines to bounds
    Object.values(routeGpsMapRef.current).forEach(({ polylines }) => {
      polylines.forEach(p => {
        try {
          const path = p.getPath();
          if (path) {
            path.forEach(point => {
              bounds.extend(point);
              hasBounds = true;
            });
          }
        } catch (e) {}
      });
    });

    // Add stop list coordinates
    if (stopList?.length > 0) {
      stopList.forEach(stop => {
        bounds.extend(new window.google.maps.LatLng(stop.location.lat, stop.location.lng));
        hasBounds = true;
      });
    }

    if (hasBounds) {
      mapRef.current.fitBounds(bounds, {
        top: 50,
        right: 50,
        bottom: 50,
        left: 50
      });

      if (mapRef.current.getZoom() > 15) {
        mapRef.current.setZoom(15);
      }
    }
  };

  const zoomToEntireRoute = () => {
    if (mapRef.current && vehicleHistory?.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();

      vehicleHistory.forEach(entry => {
        bounds.extend(new window.google.maps.LatLng(entry.location.lat, entry.location.lon));
      });

      mapRef.current.fitBounds(bounds, {
        top: 50,
        right: 50,
        bottom: 50,
        left: 50
      });

      if (mapRef.current.getZoom() > 15) {
        mapRef.current.setZoom(15);
      }
    }
  }

  const handleRouteChange = (selectedRouteId, preserveMultiRoutes = false) => {
    const routeId = isNaN(selectedRouteId) ? selectedRouteId : Number(selectedRouteId);
    const selectedRoute = routes.find(route => route._id == routeId);
    if (selectedRoute) {
      // Clear existing stop markers (ref-count aware)
      markersRef.current.forEach(entry => removeStopMarkerEntry(entry));
      markersRef.current = [];
      setStopList([]);

      // Clear vehicle history
      setVehicleHistory(null);
      vehicleHistoryRef.current = null;

      // Clear planned route state
      setPlannedRoutePath(null);
      setRoutePathUpdatedAt(null);

      if (preserveMultiRoutes) {
        // Only clear GPS history polylines/markers, preserve other routes' planned polylines
        if (routePolylines && Array.isArray(routePolylines)) {
          routePolylines.forEach((polyline) => {
            try { if (polyline && typeof polyline.setMap === 'function') polyline.setMap(null); } catch (e) {}
          });
        }
        if (routeMarkers && Array.isArray(routeMarkers)) {
          routeMarkers.forEach((marker) => {
            try { if (marker && typeof marker.setMap === 'function') marker.setMap(null); } catch (e) {}
          });
        }
        // Do NOT remove plannedRoutePolylineRef — it's stored in routePolylineMapRef and should stay visible
        plannedRoutePolylineRef.current = null;
        setRoutePolylines([]);
        setRouteMarkers([]);
      } else {
        // Clean up all map elements
        cleanupMapElements();
      }

      // Clear walking/driving/measurement
      clearWalkingRoute();
      clearDrivingRoute();
      clearMeasurement();

      setCurrentRoute(selectedRoute);
      setCurrentProject(customerSummary.projects.find(p => p.routes.find(r => r._id == routeId)));
      if (customerSummary) {
        const newVehicle = customerSummary.vehicles[selectedRoute.vehicleId];
        setCurrentVehicle(newVehicle);
      }

      if (showSidebar) {
        handleCloseSidebar();
      }
    }
  };

  const getRouteColor = (routeId) => {
    return getOrAssignRouteColor(routeId);
  };

  const handleRouteToggle = (compositeId) => {
    setRouteInfoPopup(null); // close any open info popup
    setGpsWarningPopup(null);
    const id = compositeId;
    const isCurrentlySelected = selectedRouteIdsRef.current.has(id);

    if (isCurrentlySelected) {
      // === Toggling OFF ===
      const next = new Set(selectedRouteIdsRef.current);
      next.delete(id);
      selectedRouteIdsRef.current = next;
      setSelectedRouteIds(new Set(next));

      // Remove this route's planned polyline from the map
      if (routePolylineMapRef.current[id]) {
        try { routePolylineMapRef.current[id].polyline.setMap(null); } catch(e) {}
        delete routePolylineMapRef.current[id];
      }

      // Remove this route's GPS polylines/markers from the map
      if (routeGpsMapRef.current[id]) {
        routeGpsMapRef.current[id].polylines.forEach(p => { try { p.setMap(null); } catch(e) {} });
        routeGpsMapRef.current[id].markers.forEach(m => { try { m.setMap(null); } catch(e) {} });
        delete routeGpsMapRef.current[id];
      }

      // Remove this route's stashed stop markers from the map (ref-count aware)
      if (routeStopMarkersMapRef.current[id]) {
        routeStopMarkersMapRef.current[id].forEach(entry => removeStopMarkerEntry(entry));
        delete routeStopMarkersMapRef.current[id];
      }

      // Release the stable color assignment so it can be reused
      delete routeColorMapRef.current[id];

      // If it was the active (GPS-showing) route, switch to another or clear
      if (currentRoute && getRouteKey(currentRoute) === id) {
        const remaining = Array.from(next);
        if (remaining.length > 0) {
          // Switch active route to last remaining checked route
          const switchToId = remaining[remaining.length - 1];
          const switchRoute = routes.find(r => getRouteKey(r) === switchToId);
          if (switchRoute) {
            // GPS elements for toggled-off route already removed above via routeGpsMapRef
            // Just clear the state refs (don't remove from map — other routes' GPS should persist)
            setRoutePolylines([]);
            setRouteMarkers([]);
            markersRef.current.forEach(entry => removeStopMarkerEntry(entry));
            markersRef.current = [];
            setStopList([]);
            setVehicleHistory(null);
            vehicleHistoryRef.current = null;
            setPlannedRoutePath(null);
            plannedRoutePolylineRef.current = null;

            setCurrentRoute(switchRoute);
            setCurrentProject(customerSummary.projects.find(p => p.routes.find(r => getRouteKey(r) === switchToId)));
            if (customerSummary) setCurrentVehicle(customerSummary.vehicles[switchRoute.vehicleId]);
          }
        } else {
          // No routes left — clear everything
          cleanupMapElements();
          markersRef.current.forEach(entry => removeStopMarkerEntry(entry));
          markersRef.current = [];
          setStopList([]);
          setVehicleHistory(null);
          vehicleHistoryRef.current = null;
          setPlannedRoutePath(null);
          setRoutePathUpdatedAt(null);
          setCurrentRoute(null);
        }
      }
    } else {
      // === Toggling ON ===
      const next = new Set(selectedRouteIdsRef.current);
      next.add(id);
      selectedRouteIdsRef.current = next;
      setSelectedRouteIds(new Set(next));

      const selectedRoute = routes.find(r => getRouteKey(r) === id);
      if (!selectedRoute) return;

      // Stash current route's GPS elements in routeGpsMapRef so they persist on the map
      if (currentRoute && routePolylines.length > 0) {
        const curId = getRouteKey(currentRoute);
        if (!routeGpsMapRef.current[curId]) {
          const curColor = getOrAssignRouteColor(curId);
          routeGpsMapRef.current[curId] = { polylines: [...routePolylines], markers: [...routeMarkers], color: curColor };
        }
      }
      // Don't remove GPS polylines from map — they're tracked in routeGpsMapRef now
      setRoutePolylines([]);
      setRouteMarkers([]);

      // Stash current stop markers so they persist on the map
      if (currentRoute && markersRef.current.length > 0) {
        const curId = getRouteKey(currentRoute);
        routeStopMarkersMapRef.current[curId] = [...markersRef.current];
      }
      markersRef.current = [];
      setStopList([]);

      // Clear vehicle history (will reload for new route)
      setVehicleHistory(null);
      vehicleHistoryRef.current = null;

      // Clear planned route state (will reload, but DON'T remove polylines from map)
      setPlannedRoutePath(null);
      setRoutePathUpdatedAt(null);

      // Set new active route — triggers fetchStopList and fetchTravelHistory via useEffects
      setCurrentRoute(selectedRoute);
      setCurrentProject(customerSummary.projects.find(p => p.routes.find(r => getRouteKey(r) === id)));
      if (customerSummary) setCurrentVehicle(customerSummary.vehicles[selectedRoute.vehicleId]);
    }

  };

  const fetchTravelHistory = useCallback((gpsUrl, fromDate = startDate, fromTime = startTime, toDate = finishDate, toTime = finishTime) => {
    if (gpsUrl) {
      const fromDateTime = new Date(fromDate);
      const [hours, minutes] = fromTime.split(':').map(Number);
      fromDateTime.setHours(hours, minutes, 0, 0);
      const fromDateISOString = fromDateTime.toISOString();

      const untilDateTime = new Date(toDate);
      const [hours2, minutes2] = toTime.split(':').map(Number);
      untilDateTime.setHours(hours2, minutes2, 0, 0);
      const untilDateISOString = untilDateTime.toISOString();

      apiService.getWithFirstResolve(`vehicle/${gpsUrl}/travelHistory?from=${fromDateISOString}&until=${untilDateISOString}`, accessToken, setProgress)
        .then(data => data.json())
        .then(data => {
          if (data.message) {
            toast.info(data.message);
            setVehicleHistory(null);
          } else {
            setVehicleHistory(data);
          }
        })
        .catch(err => {
          toast.error(err.message);
          setVehicleHistory(null);
        });
    }
  }, [accessToken, setProgress]);

  // Draw GPS history data directly on the map for a given route (does NOT use vehicleHistory state)
  const drawGpsDirectly = (historyData, gpsColor, routeId) => {
    if (!mapRef.current || !window.google || !historyData?.length) return;
    const rid = String(routeId);

    // Clean up old GPS for this route
    if (routeGpsMapRef.current[rid]) {
      routeGpsMapRef.current[rid].polylines.forEach(p => { try { p.setMap(null); } catch(e) {} });
      routeGpsMapRef.current[rid].markers.forEach(m => { try { m.setMap(null); } catch(e) {} });
      delete routeGpsMapRef.current[rid];
    }

    const newPolylines = [];
    const newMarkers = [];

    const allPath = historyData.map(entry => ({
      lat: entry.location.lat,
      lng: entry.location.lon
    }));

    if (allPath.length > 1) {
      const mainPolyline = new window.google.maps.Polyline({
        path: allPath,
        geodesic: true,
        strokeColor: gpsColor,
        strokeOpacity: 1.0,
        strokeWeight: 5,
        clickable: false,
        icons: [{
          icon: {
            path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            scale: 3, strokeColor: '#ffffff', strokeWeight: 1,
            fillColor: gpsColor, fillOpacity: 1
          },
          offset: '0', repeat: '100px'
        }]
      });
      mainPolyline.setMap(mapRef.current);
      newPolylines.push(mainPolyline);
    }

    // Start marker
    if (historyData.length > 0) {
      const startEntry = historyData[0];
      const startTime = new Date(startEntry.ts);
      const startMarker = new window.google.maps.Marker({
        position: { lat: startEntry.location.lat, lng: startEntry.location.lon },
        map: mapRef.current,
        icon: {
          url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
              <circle cx="20" cy="20" r="18" fill="#4CAF50" stroke="#ffffff" stroke-width="2"/>
              <polygon points="14,10 30,20 14,30" fill="#ffffff"/>
            </svg>
          `),
          scaledSize: new window.google.maps.Size(20, 20)
        },
        zIndex: 1000
      });
      const startInfoWindow = new window.google.maps.InfoWindow({
        content: `
          <div style="font-family: Arial, sans-serif; font-size: 12px; background: #000; color: #fff; padding: 10px; min-width: 200px;">
            <div style="display: flex; align-items: center; margin-bottom: 8px;">
              <span style="font-size: 16px; margin-right: 6px;">▶️</span>
              <h4 style="margin: 0; color: #4CAF50; font-size: 14px;">Başlangıç Noktası</h4>
            </div>
            <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Saat:</strong> <span>${startTime.toLocaleTimeString('tr-TR')}</span></p>
            <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Tarih:</strong> <span>${startTime.toLocaleDateString('tr-TR')}</span></p>
            <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Hız:</strong> <span>${startEntry.speed || 0} km/h</span></p>
            <p style="margin: 3px 0; font-size: 10px; color: #aaa; display: flex; justify-content: space-between;">
              <span>Koordinat:</span> <span>${startEntry.location.lon.toFixed(6)}, ${startEntry.location.lat.toFixed(6)}</span>
            </p>
          </div>
        `
      });
      startMarker.addListener('click', () => {
        if (activeInfoWindowRef.current) activeInfoWindowRef.current.close();
        startInfoWindow.open(mapRef.current, startMarker);
        activeInfoWindowRef.current = startInfoWindow;
      });
      newMarkers.push(startMarker);
    }

    // End marker
    if (historyData.length > 0) {
      const lastEntry = historyData[historyData.length - 1];
      const endTime = new Date(lastEntry.ts);
      const endMarker = new window.google.maps.Marker({
        position: { lat: lastEntry.location.lat, lng: lastEntry.location.lon },
        map: mapRef.current,
        icon: {
          url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
              <circle cx="20" cy="20" r="18" fill="#ff0000" stroke="#ffffff" stroke-width="2"/>
              <text x="20" y="28" font-family="Arial" font-size="24" fill="#ffffff" text-anchor="middle">X</text>
            </svg>
          `),
          scaledSize: new window.google.maps.Size(20, 20)
        }
      });
      const endInfoWindow = new window.google.maps.InfoWindow({
        content: `
          <div style="font-family: Arial, sans-serif; font-size: 12px; background: #000; color: #fff; padding: 10px; min-width: 200px;">
            <div style="display: flex; align-items: center; margin-bottom: 8px;">
              <span style="font-size: 16px; margin-right: 6px;">🏁</span>
              <h4 style="margin: 0; color: #ff0000; font-size: 14px;">Bitiş Noktası</h4>
            </div>
            <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Saat:</strong> <span>${endTime.toLocaleTimeString('tr-TR')}</span></p>
            <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Tarih:</strong> <span>${endTime.toLocaleDateString('tr-TR')}</span></p>
            <p style="margin: 3px 0; color: #fff; display: flex; justify-content: space-between;"><strong style="color: #5a9bd4;">Hız:</strong> <span>${lastEntry.speed || 0} km/h</span></p>
            <p style="margin: 3px 0; font-size: 10px; color: #aaa; display: flex; justify-content: space-between;">
              <span>Koordinat:</span> <span>${lastEntry.location.lon.toFixed(6)}, ${lastEntry.location.lat.toFixed(6)}</span>
            </p>
          </div>
        `
      });
      endMarker.addListener('click', () => {
        if (activeInfoWindowRef.current) activeInfoWindowRef.current.close();
        endInfoWindow.open(mapRef.current, endMarker);
        activeInfoWindowRef.current = endInfoWindow;
      });
      newMarkers.push(endMarker);
    }

    routeGpsMapRef.current[rid] = { polylines: newPolylines, markers: newMarkers, color: gpsColor };
  };

  // Re-fetch GPS for all selected routes (non-active ones) when time range changes
  const refreshOtherRoutesGps = (fromDate, fromTime, toDate, toTime) => {
    if (!customerSummary || !routes) return;
    const activeId = currentRoute ? getRouteKey(currentRoute) : null;

    selectedRouteIdsRef.current.forEach(rid => {
      if (rid === activeId) return; // active route is handled by fetchTravelHistory
      const route = routes.find(r => getRouteKey(r) === rid);
      if (!route) return;
      const vehicle = customerSummary.vehicles[route.vehicleId];
      if (!hasValidGpsUrl(vehicle)) return;

      const fromDateTime = new Date(fromDate);
      const [h1, m1] = fromTime.split(':').map(Number);
      fromDateTime.setHours(h1, m1, 0, 0);
      const untilDateTime = new Date(toDate);
      const [h2, m2] = toTime.split(':').map(Number);
      untilDateTime.setHours(h2, m2, 0, 0);

      const color = routeColorMapRef.current[rid] || '#3151f5';
      apiService.getWithFirstResolve(
        `vehicle/${vehicle.gpsUrl}/travelHistory?from=${fromDateTime.toISOString()}&until=${untilDateTime.toISOString()}`,
        accessToken, setProgress
      )
        .then(data => data.json())
        .then(data => {
          if (!data.message && data.length > 0) {
            drawGpsDirectly(data, color, rid);
          } else {
            // No data — clear old GPS for this route
            if (routeGpsMapRef.current[rid]) {
              routeGpsMapRef.current[rid].polylines.forEach(p => { try { p.setMap(null); } catch(e) {} });
              routeGpsMapRef.current[rid].markers.forEach(m => { try { m.setMap(null); } catch(e) {} });
              delete routeGpsMapRef.current[rid];
            }
          }
        })
        .catch(() => {});
    });
  };

  // Quick date selection helpers
  const setToday = useCallback(() => {
    const today = new Date();
    setStartDate(today);
    setFinishDate(today);
    if (hasValidGpsUrl(currentVehicle)) {
      fetchTravelHistory(currentVehicle.gpsUrl, today, startTime, today, finishTime);
      refreshOtherRoutesGps(today, startTime, today, finishTime);
    }
  }, [currentVehicle, startTime, finishTime, fetchTravelHistory]);

  const setOneDayBefore = useCallback(() => {
    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    setStartDate(yesterday);
    setFinishDate(yesterday);
    if (hasValidGpsUrl(currentVehicle)) {
      fetchTravelHistory(currentVehicle.gpsUrl, yesterday, startTime, yesterday, finishTime);
      refreshOtherRoutesGps(yesterday, startTime, yesterday, finishTime);
    }
  }, [currentVehicle, startTime, finishTime, fetchTravelHistory, now]);

  const setTwoDaysBefore = useCallback(() => {
    const twoDaysAgo = new Date();
    twoDaysAgo.setDate(now.getDate() - 2);
    setStartDate(twoDaysAgo);
    setFinishDate(twoDaysAgo);
    if (hasValidGpsUrl(currentVehicle)) {
      fetchTravelHistory(currentVehicle.gpsUrl, twoDaysAgo, startTime, twoDaysAgo, finishTime);
      refreshOtherRoutesGps(twoDaysAgo, startTime, twoDaysAgo, finishTime);
    }
  }, [currentVehicle, startTime, finishTime, fetchTravelHistory, now]);

  const setThreeDaysBefore = useCallback(() => {
    const threeDaysAgo = new Date();
    threeDaysAgo.setDate(now.getDate() - 3);
    setStartDate(threeDaysAgo);
    setFinishDate(threeDaysAgo);
    if (hasValidGpsUrl(currentVehicle)) {
      fetchTravelHistory(currentVehicle.gpsUrl, threeDaysAgo, startTime, threeDaysAgo, finishTime);
      refreshOtherRoutesGps(threeDaysAgo, startTime, threeDaysAgo, finishTime);
    }
  }, [currentVehicle, startTime, finishTime, fetchTravelHistory, now]);

  // Fetch travel history when vehicle or route changes
  useEffect(() => {
    if (hasValidGpsUrl(currentVehicle)) {
      fetchTravelHistory(currentVehicle.gpsUrl, startDate, startTime, finishDate, finishTime);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentVehicle, currentRoute, fetchTravelHistory]);

  // Remove a stop marker entry; for shared last-stop markers, decrement refCount and only hide when 0
  const removeStopMarkerEntry = (entry) => {
    if (entry.isLastStop && entry.locKey) {
      const shared = lastStopMarkersRef.current[entry.locKey];
      if (shared) {
        shared.refCount--;
        if (shared.refCount <= 0) {
          try { shared.marker.setMap(null); } catch(e) {}
          delete lastStopMarkersRef.current[entry.locKey];
        }
      }
    } else {
      try { entry.marker.setMap(null); } catch(e) {}
    }
  };

  const addStopsToMap = (stops, routeColor) => {
    if (!mapRef.current || !window.google) {
      // Map not ready yet, will be retried by googleMapsLoaded useEffect
      return;
    }

    // Resolve color: passed explicitly, or from current route, or default
    const color = routeColor
      || (currentRoute && routeColorMapRef.current[getRouteKey(currentRoute)])
      || '#14345c';

    // Remove existing stop markers (ref-count aware for shared last-stop markers)
    markersRef.current.forEach(entry => removeStopMarkerEntry(entry));
    markersRef.current = [];

    // Add markers for each stop; last stop gets a distinct star icon (shared/deduped)
    const lastIdx = stops.length - 1;
    stops.forEach((stop, idx) => addMarkerToMap(stop, idx === lastIdx, color));
  };

  const addMarkerToMap = (stop, isLastStop = false, stopColor = '#14345c') => {
    const lat = parseFloat(stop.location.lat);
    const lng = parseFloat(stop.location.lng);
    if (isNaN(lat) || isNaN(lng)) return;

    // Last stop: use a shared marker so duplicate company-address stops render only once
    if (isLastStop) {
      const locKey = `${lat.toFixed(5)}_${lng.toFixed(5)}`;
      if (lastStopMarkersRef.current[locKey]) {
        // Already displayed — just bump the ref count
        lastStopMarkersRef.current[locKey].refCount++;
        // Store a reference so cleanup can decrement
        markersRef.current.push({ id: stop._id, marker: lastStopMarkersRef.current[locKey].marker, isLastStop: true, locKey });
        return;
      }

      const marker = new window.google.maps.Marker({
        position: { lat, lng },
        map: mapRef.current,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 14,
          fillColor: '#f59e0b',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2
        },
        label: {
          text: '\u2605',
          color: '#ffffff',
          fontSize: '14px',
          fontWeight: 'bold'
        },
        zIndex: 600
      });

      marker.addListener('click', () => {
        if (activeInfoWindowRef.current) activeInfoWindowRef.current.close();
        const infoWindow = new window.google.maps.InfoWindow({
          content: `<div style="font-family: Arial, sans-serif; font-size: 12px; background: #000; color: #fff; padding: 10px; min-width: 160px;">
            <h4 style="margin: 5px 0; color: #f59e0b;">&#11088; ${stop.name || 'Son Durak'}</h4>
            ${stop.note ? `<p style="margin: 5px 0; color: #fff;"><strong style="color: #f59e0b;">Not:</strong> ${stop.note}</p>` : ''}
          </div>`
        });
        infoWindow.open(mapRef.current, marker);
        activeInfoWindowRef.current = infoWindow;
      });

      lastStopMarkersRef.current[locKey] = { marker, refCount: 1 };
      markersRef.current.push({ id: stop._id, marker, isLastStop: true, locKey });
      return;
    }

    const marker = new window.google.maps.Marker({
      position: { lat, lng },
      map: mapRef.current,
      icon: {
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: 14,
        fillColor: stop.isPassive ? '#808080' : stopColor,
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 2
      },
      label: {
        text: stop.order.toString(),
        color: '#ffffff',
        fontSize: '12px',
        fontWeight: 'bold'
      },
      zIndex: 500
    });

    // Show stop info on click with an InfoWindow
    marker.addListener('click', () => {
      const visitTimesHtml = stop.visitTimes && stop.visitTimes.length > 0
        ? `<div style="margin-top: 10px; padding-top: 10px; border-top: 1px solid rgba(20, 52, 92, 0.3);">
            <p style="margin: 3px 0; color: #5a9bd4; font-weight: bold;">Plananlanan sefer saatleri:</p>
            ${stop.visitTimes.slice(0, 5).map((visitTime, index) => {
              const startTimeVal = visitTime.start ? visitTime.start.substring(0, 5) : '';
              const returnTime = visitTime.return ? visitTime.return.substring(0, 5) : '';
              return `<p style="margin: 3px 0; font-size: 11px;">${index + 1}. Giriş: ${startTimeVal} - Çıkış: ${returnTime}</p>`;
            }).join('')}
            ${stop.visitTimes.length > 5 ? `<p style="margin: 3px 0; font-size: 11px; color: #aaa;">+${stop.visitTimes.length - 5} daha...</p>` : ''}
          </div>`
        : '';

      const description = `
        <div style="font-family: Arial, sans-serif; font-size: 12px; background: #000; color: #fff; padding: 10px; min-width: 200px;">
          <h4 style="margin: 5px 0; color: #5a9bd4;">📍 ${stop.order}. ${stop.name || 'İsimsiz'}</h4>
          ${stop.note ? `<p style="margin: 5px 0; color: #fff;"><strong style="color: #5a9bd4;">Not:</strong> ${stop.note}</p>` : ''}
          ${visitTimesHtml}
        </div>
      `;

      if (activeInfoWindowRef.current) activeInfoWindowRef.current.close();
      const infoWindow = new window.google.maps.InfoWindow({
        content: description
      });

      infoWindow.open(mapRef.current, marker);
      activeInfoWindowRef.current = infoWindow;
    });

    // Store the marker reference
    markersRef.current.push({ id: stop._id, marker });
  };

  const fetchStopList = useCallback(async (projectId, routeId, compositeKey) => {
    if (!projectId || !routeId) return;
    const rid = compositeKey || String(routeId);

    try {
      const response = await apiService.get(`projects/${projectId}/vehicles/${routeId}/stopList`, accessToken, setProgress);
      if (response.error) {
        toast.error(response.error);
      } else {
        const { stops, routePath, routePathUpdatedAt } = response;

        const transformedStops = stops.map(stop => ({
          _id: stop.id,
          name: stop.name,
          location: { lat: stop.lat, lng: stop.lon },
          order: stop.order,
          note: stop.note,
          isPassive: stop.isPassive,
          visitTimes: stop.visitTimes || []
        }));

        setStopList(transformedStops);
        addStopsToMap(transformedStops, routeColorMapRef.current[rid]);

        if (routePath) {
          setPlannedRoutePath(routePath);
          setRoutePathUpdatedAt(routePathUpdatedAt);
          // Remove old polyline for THIS route if re-fetching
          if (routePolylineMapRef.current[rid]) {
            try { routePolylineMapRef.current[rid].polyline.setMap(null); } catch(e) {}
            delete routePolylineMapRef.current[rid];
          }
          const color = routeColorMapRef.current[rid] || '#14345c';
          // Use ref to always get latest function (avoids stale useCallback closure)
          const createPolyline = addPlannedRouteToMapRef.current || addPlannedRouteToMap;
          const polyline = createPolyline(routePath, color);
          if (polyline) {
            routePolylineMapRef.current[rid] = { polyline, color };
            plannedRoutePolylineRef.current = polyline;
          }
        }
      }
    } catch (error) {
      console.error('Error fetching stop list:', error);
      toast.error('Durakları getirirken bir hata oluştu');
    }
  }, [accessToken, setProgress]);

  useEffect(() => {
    if (currentRoute && customerSummary) {
      const projectId = customerSummary.projects.find(p => p.routes.find(r => r._id === currentRoute._id))?.id;
      if (projectId) {
        fetchStopList(projectId, currentRoute._id, getRouteKey(currentRoute));
      }
    }
  }, [currentRoute, customerSummary, fetchStopList]);

  // When the map becomes ready, re-render stops and planned route that may have been fetched before map init
  useEffect(() => {
    if (mapRef.current && googleMapsLoaded) {
      if (stopList?.length > 0) {
        const stopColor = currentRoute ? routeColorMapRef.current[getRouteKey(currentRoute)] : undefined;
        addStopsToMap(stopList, stopColor);
      }
      if (plannedRoutePath && currentRoute) {
        const rid = getRouteKey(currentRoute);
        if (!routePolylineMapRef.current[rid]) {
          const color = routeColorMapRef.current[rid] || '#14345c';
          const polyline = addPlannedRouteToMap(plannedRoutePath, color);
          if (polyline) {
            routePolylineMapRef.current[rid] = { polyline, color };
            plannedRoutePolylineRef.current = polyline;
          }
        }
      }
    }
  }, [googleMapsLoaded]);

  // Re-zoom when stop list, planned route, or vehicle history becomes available
  useEffect(() => {
    if (stopList?.length > 0 || plannedRoutePath || vehicleHistory?.length > 0) {
      zoomToBothRoutes();
    }
  }, [stopList, plannedRoutePath, vehicleHistory]);

  const handleLogout = () => {
    localStorage.removeItem('kentist-musteri-accessToken');
    window.location.href = '/';
  };

  // Help modal state
  const [showHelpModal, setShowHelpModal] = useState(null); // null, 'measurement', 'walking', 'driving'

  const helpContent = {
    measurement: {
      title: 'Ölçüm Modu',
      color: '#FFA500',
      body: [
        'Haritada noktalar arasındaki mesafeyi ölçmenizi sağlar.',
        '• "Ölçüm" butonuna tıklayarak modu aktif edin.',
        '• Haritada tıklayarak ölçüm noktaları ekleyin.',
        '• Noktaları sürükleyerek konumlarını değiştirin.',
        '• Bir noktayı silmek için üzerine sağ tıklayın.',
        '• Modu kapatmak için butona tekrar tıklayın.'
      ]
    },
    walking: {
      title: 'Yürüyüş Rotası',
      color: '#008000',
      body: [
        'İki nokta arasında yürüyüş rotası hesaplar.',
        '• "Yürüyüş" butonuna tıklayarak modu aktif edin.',
        '• Haritada tek tıklayarak başlangıç noktası (A) belirleyin.',
        '• Ara noktalar eklemek için tek tıklamaya devam edin.',
        '• Bitiş noktasını (B) belirlemek için çift tıklayın.',
        '• A ve B noktalarını sürükleyerek rotayı güncelleyin.',
        '• Modu kapatmak için butona tekrar tıklayın.'
      ]
    },
    driving: {
      title: 'Araç Rotası',
      color: '#9932CC',
      body: [
        'İki nokta arasında araç rotası hesaplar.',
        '• "Araç" butonuna tıklayarak modu aktif edin.',
        '• Haritada tek tıklayarak başlangıç noktası (A) belirleyin.',
        '• Ara noktalar eklemek için tek tıklamaya devam edin.',
        '• Bitiş noktasını (B) belirlemek için çift tıklayın.',
        '• A ve B noktalarını sürükleyerek rotayı güncelleyin.',
        '• Modu kapatmak için butona tekrar tıklayın.'
      ]
    }
  };

  // Mode toggle buttons component (reused in left pane and offcanvas)
  const ModeToggleButtons = () => (
    <>
      <ButtonGroup size="sm" style={{ marginTop: 10, width: '100%' }}>
        <Button
          onClick={toggleMeasurementMode}
          active={isMeasurementMode}
          style={{
            background: isMeasurementMode ? '#FFA500' : 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
            border: 'none',
            color: '#fff',
            fontSize: '10px'
          }}
        >
          <FontAwesomeIcon icon={faRuler} /> Ölçüm
          <FontAwesomeIcon
            icon={faInfoCircle}
            style={{ marginLeft: 4, opacity: 0.7, cursor: 'pointer' }}
            onClick={(e) => { e.stopPropagation(); setShowHelpModal('measurement'); }}
          />
        </Button>
        <Button
          onClick={toggleWalkingRoute}
          active={isWalkingMode}
          style={{
            background: isWalkingMode ? '#008000' : 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
            border: 'none',
            color: '#fff',
            fontSize: '10px'
          }}
        >
          <FontAwesomeIcon icon={faWalking} /> Yürüyüş
          <FontAwesomeIcon
            icon={faInfoCircle}
            style={{ marginLeft: 4, opacity: 0.7, cursor: 'pointer' }}
            onClick={(e) => { e.stopPropagation(); setShowHelpModal('walking'); }}
          />
        </Button>
        <Button
          onClick={toggleDrivingRoute}
          active={isDrivingMode}
          style={{
            background: isDrivingMode ? '#9932CC' : 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
            border: 'none',
            color: '#fff',
            fontSize: '10px'
          }}
        >
          <FontAwesomeIcon icon={faCar} /> Araç
          <FontAwesomeIcon
            icon={faInfoCircle}
            style={{ marginLeft: 4, opacity: 0.7, cursor: 'pointer' }}
            onClick={(e) => { e.stopPropagation(); setShowHelpModal('driving'); }}
          />
        </Button>
      </ButtonGroup>
      {measurementDistance && (
        <div style={{ marginTop: 5, fontSize: '11px', color: '#FFA500', fontWeight: 'bold' }}>
          Mesafe: {measurementDistance}
        </div>
      )}
      {walkingDistance && (
        <div style={{ marginTop: 5, fontSize: '11px', color: '#008000', fontWeight: 'bold' }}>
          Yürüyüş: {walkingDistance} - {walkingDuration}
        </div>
      )}
      {drivingDistance && (
        <div style={{ marginTop: 5, fontSize: '11px', color: '#9932CC', fontWeight: 'bold' }}>
          Araç: {drivingDistance} - {drivingDuration}
        </div>
      )}
    </>
  );

  return (
    <div style={{
      height: '100vh',
      background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%)',
      color: '#fff',
      position: 'relative'
    }}>
      {/* Logo - Centered Bottom */}
      <div className="logo-overlay" style={{
        position: 'absolute',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 5,
        background: 'white',
        padding: '4px 10px',
        borderRadius: '20px',
        border: '2px solid rgba(20, 52, 92, 0.4)',
        cursor: 'pointer',
        transition: 'transform 0.2s ease, boxShadow 0.2s ease'
      }}
      onClick={() => window.location.href = '/'}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateX(-50%) scale(1.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateX(-50%) scale(1)';
      }}>
        <img
          src={`${process.env.PUBLIC_URL}/kentist-logo.png`}
          alt="Kentist Turizm"
          style={{
            width: '120px',
            pointerEvents: 'none'
          }}
        />
      </div>

      {/* Address Search Box */}
      <div style={{
        position: 'absolute',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        width: '320px'
      }}>
        <div style={{
          position: 'relative',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
          border: '2px solid rgba(20, 52, 92, 0.6)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            padding: '8px 12px'
          }}>
            <FontAwesomeIcon
              icon={faSearch}
              style={{
                color: '#ccc',
                marginRight: '8px',
                fontSize: '14px'
              }}
            />
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearchChange}
              placeholder="Adres veya sokak ara..."
              style={{
                flex: 1,
                border: 'none',
                outline: 'none',
                backgroundColor: 'transparent',
                color: '#fff',
                fontSize: '14px'
              }}
            />
            {searchQuery && (
              <FontAwesomeIcon
                icon={faTimes}
                onClick={clearSearch}
                style={{
                  color: '#ccc',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              />
            )}
          </div>

          {showSearchResults && searchResults.length > 0 && (
            <div style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.95)',
              borderRadius: '0 0 8px 8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              maxHeight: '200px',
              overflowY: 'auto',
              zIndex: 1001
            }}>
              {searchResults.map((result, index) => (
                <div
                  key={index}
                  onClick={() => handleSearchResultClick(result)}
                  style={{
                    padding: '10px 12px',
                    cursor: 'pointer',
                    borderBottom: index < searchResults.length - 1 ? '1px solid #555' : 'none',
                    color: '#fff',
                    fontSize: '13px',
                    lineHeight: '1.4'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                  }}
                >
                  {result.place_name}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Clock and Logout - Top Right */}
      <div className="top-right-controls" style={{
        position: 'absolute',
        top: '20px',
        right: '20px',
        zIndex: 5,
        display: 'flex',
        gap: '15px',
        alignItems: 'center'
      }}>
        <div className="clock-container" style={{
          background: 'rgba(0, 0, 0, 0.7)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          padding: '10px 15px',
          borderRadius: '10px',
          border: '2px solid rgba(20, 52, 92, 0.4)',
          boxShadow: '0 4px 20px rgba(20, 52, 92, 0.3)'
        }}>
          <Clock />
        </div>
        <Button
          size="sm"
          onClick={handleLogout}
          style={{
            background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
            border: 'none',
            color: '#fff',
            fontWeight: '700',
            boxShadow: '0 4px 20px rgba(20, 52, 92, 0.4)',
            padding: '10px 20px',
            borderRadius: '10px'
          }}
        >
          Çıkış yap
        </Button>
      </div>
      <Offcanvas show={showSidebar} onHide={handleCloseSidebar}
                 style={{
                   background: '#000000',
                   color: '#fff',
                   border: '2px solid rgba(20, 52, 92, 0.4)'
                 }}>
        <Offcanvas.Header closeButton style={{
          borderBottom: '2px solid rgba(20, 52, 92, 0.4)'
        }}>
          <Offcanvas.Title style={{ color: '#5a9bd4', fontWeight: 600 }}>Ayarlar</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>

          {/* Route Ticker - mobile view */}
          <Row style={{ marginTop: '20px' }}>
            <h6 style={{ color: '#5a9bd4', fontWeight: 600 }}>Güzergah</h6>
            <Col>
              <div style={{
                maxHeight: '150px',
                overflowY: 'auto',
                background: 'rgba(0,0,0,0.8)',
                border: '1px solid rgba(20, 52, 92, 0.5)',
                borderRadius: '6px',
                fontSize: '13px'
              }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <tbody>
                    {routes.map((route) => {
                      const rk = getRouteKey(route);
                      const isChecked = selectedRouteIds.has(rk);
                      const isCurrent = currentRoute && getRouteKey(currentRoute) === rk;
                      const color = getRouteColor(rk);
                      const routeVehicle = customerSummary?.vehicles[route.vehicleId];
                      return (
                        <tr
                          key={rk}
                          onClick={() => handleRouteToggle(rk)}
                          style={{
                            cursor: 'pointer',
                            background: isCurrent ? 'rgba(20, 52, 92, 0.4)' : 'transparent',
                            fontWeight: isCurrent ? 'bold' : 'normal',
                            borderBottom: '1px solid rgba(255,255,255,0.07)'
                          }}
                          onMouseEnter={(e) => { if (!isCurrent) e.currentTarget.style.background = 'rgba(20, 52, 92, 0.2)'; }}
                          onMouseLeave={(e) => { if (!isCurrent) e.currentTarget.style.background = 'transparent'; }}
                        >
                          <td style={{ width: '30px', textAlign: 'center', padding: '6px 4px' }}>
                            <input type="checkbox" checked={isChecked} onChange={() => {}} style={{ accentColor: color, cursor: 'pointer' }} />
                          </td>
                          <td style={{ padding: '6px 4px', color: '#fff' }}>
                            {isChecked && <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: color, marginRight: 6 }} />}
                            {routeVehicle?.plate && <span style={{ color: '#f0ad4e', fontWeight: 'bold', marginRight: 4, fontSize: '11px' }}>[{routeVehicle.plate}]</span>}
                            {route.name}
                            {!hasValidGpsUrl(routeVehicle) && (
                              <FontAwesomeIcon
                                icon={faExclamationCircle}
                                style={{ color: '#ff6b6b', marginLeft: 6, fontSize: '12px', cursor: 'pointer' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setRouteInfoPopup(null);
                                  if (gpsWarningPopup?.routeId === rk) {
                                    setGpsWarningPopup(null);
                                  } else {
                                    const rect = e.currentTarget.getBoundingClientRect();
                                    setGpsWarningPopup({ routeId: rk, top: rect.top + rect.height / 2, left: rect.left });
                                  }
                                }}
                              />
                            )}
                          </td>
                          <td style={{ width: '30px', textAlign: 'center', padding: '6px 4px' }}>
                            <FontAwesomeIcon
                              icon={faInfoCircle}
                              style={{ color: '#5a9bd4', cursor: 'pointer', fontSize: '14px' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setGpsWarningPopup(null);
                                if (routeInfoPopup?.routeId === rk) {
                                  setRouteInfoPopup(null);
                                } else {
                                  const rect = e.currentTarget.getBoundingClientRect();
                                  setRouteInfoPopup({ routeId: rk, top: rect.top + rect.height / 2, left: rect.left });
                                }
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <span style={{ fontSize: '16px', fontWeight: 500, color: '#5a9bd4' }}>Saat & tarih:</span>
            <div style={{ display: 'flex', gap: 8 }}>
              <div style={{ flex: 1 }}>
                <div className="d-flex justify-content-end align-items-center">
                  <input style={{ marginRight: 10, display: 'inline-block', width: 'auto' }} className="form-control" value={startTime} onChange={(time) => setStartTime(time.target.value)} type="time" />
                  <DatePicker
                    className="form-control"
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    locale={turkishLocale}
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
                <div className="d-flex justify-content-end align-items-center" style={{ marginTop: 10 }}>
                  <input style={{ marginRight: 10, display: 'inline-block', width: 'auto' }} className="form-control" value={finishTime} onChange={(time) => setFinishTime(time.target.value)} type="time" />
                  <DatePicker
                    className="form-control"
                    selected={finishDate}
                    onChange={(date) => setFinishDate(date)}
                    locale={turkishLocale}
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
              </div>
              <Button
                size="sm"
                style={{
                  background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
                  border: 'none',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '13px',
                  padding: '0 14px',
                  whiteSpace: 'nowrap',
                  alignSelf: 'stretch'
                }}
                disabled={!hasValidGpsUrl(currentVehicle)}
                onClick={() => { handleCloseSidebar(); handleHistoryFilter(); }}
              >
                Sorgula
              </Button>
            </div>
          </Row>
          <Row>
            <Col>
              <Col xs={2} style={{ marginTop: 10, width: '100%' }} className="d-flex justify-content-end flex-wrap">
                <Button size="sm" style={{
                  marginLeft: 2,
                  marginBottom: 2,
                  fontSize: '10px',
                  whiteSpace: 'nowrap',
                  background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
                  border: 'none',
                  color: '#fff'
                }} disabled={!hasValidGpsUrl(currentVehicle)} onClick={e => { setThreeDaysBefore(); }}>
                  3 gün önce
                </Button>
                <Button size="sm" style={{
                  marginLeft: 2,
                  marginBottom: 2,
                  fontSize: '10px',
                  whiteSpace: 'nowrap',
                  background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
                  border: 'none',
                  color: '#fff'
                }} disabled={!hasValidGpsUrl(currentVehicle)} onClick={e => { setTwoDaysBefore(); }}>
                  2 gün önce
                </Button>
                <Button size="sm" style={{
                  marginLeft: 2,
                  marginBottom: 2,
                  fontSize: '10px',
                  whiteSpace: 'nowrap',
                  background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
                  border: 'none',
                  color: '#fff'
                }} disabled={!hasValidGpsUrl(currentVehicle)} onClick={e => { setOneDayBefore(); }}>
                  1 gün önce
                </Button>
                <Button size="sm" style={{
                  marginLeft: 2,
                  marginBottom: 2,
                  fontSize: '10px',
                  whiteSpace: 'nowrap',
                  background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
                  border: 'none',
                  color: '#fff'
                }} disabled={!hasValidGpsUrl(currentVehicle)} onClick={e => { setToday(); }}>
                  Bugün
                </Button>
              </Col>
            </Col>
          </Row>
          {vehicleHistory?.length > 0 && (() => {
            const first = new Date(vehicleHistory[0].ts);
            const last = new Date(vehicleHistory[vehicleHistory.length - 1].ts);
            const fmt = (d) => `${d.toLocaleDateString('tr-TR')} ${d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}`;
            return (
              <Row>
                <Col>
                  <div style={{ fontSize: '10px', color: '#5a9bd4', textAlign: 'right', padding: '2px 4px', opacity: 0.8 }}>
                    Gösterilen GPS verisi: {fmt(first)} — {fmt(last)}
                  </div>
                </Col>
              </Row>
            );
          })()}
          <Row>
            <Col>
              <ModeToggleButtons />
            </Col>
          </Row>
        </Offcanvas.Body>
      </Offcanvas>

      <div style={{ height: '100%', position: 'relative' }}>
        {/* Map container - no React children, Google Maps owns this DOM */}
        <div ref={mapContainerRef} id="map-container" style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }} />

        {/* Overlays rendered outside the map container to avoid DOM conflicts */}
        <div id="ayarlar-button-wrapper" style={{zIndex: 4, position: 'absolute', top: 20, left: 20}}>
          <Button id="open-sidebar-button" onClick={handleShowSidebar} style={{
            background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
            border: 'none',
            color: '#fff',
            fontWeight: '700',
            boxShadow: '0 4px 20px rgba(20, 52, 92, 0.4)',
            padding: '10px 20px',
            borderRadius: '10px'
          }}>
            Ayarlar
          </Button>
        </div>

        <div style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          zIndex: 1000,
          maxWidth: '300px',
        }}>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme={darkMode ? "dark" : "light"}
            style={{ fontSize: '14px' }}
          />
        </div>
        {leftPaneCollapsed && (
          <div style={{
            position: 'absolute',
            top: '10px',
            left: '10px',
            zIndex: 5
          }}>
            <Button
              size="sm"
              onClick={() => setLeftPaneCollapsed(false)}
              style={{
                background: '#000000',
                border: '2px solid rgba(20, 52, 92, 0.4)',
                color: '#5a9bd4',
                padding: '8px 10px',
                borderRadius: '12px',
                fontSize: '14px',
                lineHeight: 1,
                boxShadow: '0 8px 40px 0 rgba(20, 52, 92, 0.3)'
              }}
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </Button>
          </div>
        )}
        <div id="left-pane" style={{
          position: 'absolute',
          top: '10px',
          left: '10px',
          background: '#000000',
          border: '2px solid rgba(20, 52, 92, 0.4)',
          padding: '15px',
          borderRadius: '15px',
          maxHeight: 'calc(100% - 20px)',
          overflow: 'hidden',
          color: '#fff',
          boxShadow: '0 8px 40px 0 rgba(20, 52, 92, 0.3)',
          zIndex: 5,
          fontSize: '14px',
          width: '350px',
          transformOrigin: 'top left',
          transform: leftPaneCollapsed ? 'scale(0)' : 'scale(1)',
          opacity: leftPaneCollapsed ? 0 : 1,
          transition: 'transform 0.3s ease, opacity 0.3s ease',
          pointerEvents: leftPaneCollapsed ? 'none' : 'auto'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <h5 style={{ fontSize: '16px', margin: 0, color: '#5a9bd4', fontWeight: 600 }}>Güzergahlar</h5>
            <Button
              size="sm"
              onClick={() => setLeftPaneCollapsed(true)}
              style={{
                background: 'transparent',
                border: '1px solid rgba(20, 52, 92, 0.4)',
                color: '#5a9bd4',
                padding: '2px 8px',
                borderRadius: '8px',
                fontSize: '12px',
                lineHeight: 1
              }}
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </Button>
          </div>
          <div style={{ overflow: 'hidden' }}>
          <Row>
            <Col>
              <div style={{
                maxHeight: '150px',
                overflowY: 'auto',
                background: 'rgba(0,0,0,0.8)',
                border: '1px solid rgba(20, 52, 92, 0.5)',
                borderRadius: '6px',
                fontSize: '12px'
              }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <tbody>
                    {routes.map((route) => {
                      const rk = getRouteKey(route);
                      const isChecked = selectedRouteIds.has(rk);
                      const isCurrent = currentRoute && getRouteKey(currentRoute) === rk;
                      const color = getRouteColor(rk);
                      const routeVehicle = customerSummary?.vehicles[route.vehicleId];
                      return (
                        <tr
                          key={rk}
                          onClick={() => handleRouteToggle(rk)}
                          style={{
                            cursor: 'pointer',
                            background: isCurrent ? 'rgba(20, 52, 92, 0.4)' : 'transparent',
                            fontWeight: isCurrent ? 'bold' : 'normal',
                            borderBottom: '1px solid rgba(255,255,255,0.07)'
                          }}
                          onMouseEnter={(e) => { if (!isCurrent) e.currentTarget.style.background = 'rgba(20, 52, 92, 0.2)'; }}
                          onMouseLeave={(e) => { if (!isCurrent) e.currentTarget.style.background = 'transparent'; }}
                        >
                          <td style={{ width: '28px', textAlign: 'center', padding: '5px 4px' }}>
                            <input type="checkbox" checked={isChecked} onChange={() => {}} style={{ accentColor: color, cursor: 'pointer' }} />
                          </td>
                          <td style={{ padding: '5px 4px', color: '#fff' }}>
                            {isChecked && <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: color, marginRight: 6 }} />}
                            {routeVehicle?.plate && <span style={{ color: '#f0ad4e', fontWeight: 'bold', marginRight: 4, fontSize: '10px' }}>[{routeVehicle.plate}]</span>}
                            {route.name}
                            {!hasValidGpsUrl(routeVehicle) && (
                              <FontAwesomeIcon
                                icon={faExclamationCircle}
                                style={{ color: '#ff6b6b', marginLeft: 6, fontSize: '11px', cursor: 'pointer' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setRouteInfoPopup(null);
                                  if (gpsWarningPopup?.routeId === rk) {
                                    setGpsWarningPopup(null);
                                  } else {
                                    const rect = e.currentTarget.getBoundingClientRect();
                                    setGpsWarningPopup({ routeId: rk, top: rect.top + rect.height / 2, left: rect.left });
                                  }
                                }}
                              />
                            )}
                          </td>
                          <td style={{ width: '28px', textAlign: 'center', padding: '5px 4px' }}>
                            <FontAwesomeIcon
                              icon={faInfoCircle}
                              style={{ color: '#5a9bd4', cursor: 'pointer', fontSize: '13px' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setGpsWarningPopup(null);
                                if (routeInfoPopup?.routeId === rk) {
                                  setRouteInfoPopup(null);
                                } else {
                                  const rect = e.currentTarget.getBoundingClientRect();
                                  setRouteInfoPopup({ routeId: rk, top: rect.top + rect.height / 2, left: rect.left });
                                }
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <span style={{ fontWeight: 500, marginBottom: '5px', color: '#5a9bd4' }}>Saat & tarih:</span>
            <div style={{ display: 'flex', gap: 6 }}>
              <div style={{ flex: 1 }}>
                <div className="d-flex justify-content-end align-items-center">
                  <input style={{ marginRight: 5, display: 'inline-block', width: 'auto' }} className="form-control form-control-sm" value={startTime} onChange={(time) => setStartTime(time.target.value)} type="time" />
                  <DatePicker
                    className="form-control form-control-sm"
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    locale={turkishLocale}
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
                <div className="d-flex justify-content-end align-items-center" style={{ marginTop: 5 }}>
                  <input style={{ marginRight: 5, display: 'inline-block', width: 'auto' }} className="form-control form-control-sm" value={finishTime} onChange={(time) => setFinishTime(time.target.value)} type="time" />
                  <DatePicker
                    className="form-control form-control-sm"
                    selected={finishDate}
                    onChange={(date) => setFinishDate(date)}
                    locale={turkishLocale}
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
              </div>
              <Button
                size="sm"
                style={{
                  background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
                  border: 'none',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '12px',
                  padding: '0 12px',
                  whiteSpace: 'nowrap',
                  alignSelf: 'stretch'
                }}
                disabled={!hasValidGpsUrl(currentVehicle)}
                onClick={() => handleHistoryFilter()}
              >
                Sorgula
              </Button>
            </div>
          </Row>
          <Row>
            <Col>
              <Col xs={2} style={{ marginTop: 10, width: '100%' }} className="d-flex justify-content-end flex-wrap">
                <Button size="sm" style={{
                  marginLeft: 2,
                  marginBottom: 2,
                  fontSize: '10px',
                  whiteSpace: 'nowrap',
                  background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
                  border: 'none',
                  color: '#fff'
                }} disabled={!hasValidGpsUrl(currentVehicle)} onClick={e => { setToday(); }}>
                  Bugün
                </Button>
                <Button size="sm" style={{
                  marginLeft: 2,
                  marginBottom: 2,
                  fontSize: '10px',
                  whiteSpace: 'nowrap',
                  background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
                  border: 'none',
                  color: '#fff'
                }} disabled={!hasValidGpsUrl(currentVehicle)} onClick={e => { setOneDayBefore(); }}>
                  1 gün önce
                </Button>
                <Button size="sm" style={{
                  marginLeft: 2,
                  marginBottom: 2,
                  fontSize: '10px',
                  whiteSpace: 'nowrap',
                  background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
                  border: 'none',
                  color: '#fff'
                }} disabled={!hasValidGpsUrl(currentVehicle)} onClick={e => { setTwoDaysBefore(); }}>
                  2 gün önce
                </Button>
                <Button size="sm" style={{
                  marginLeft: 2,
                  marginBottom: 2,
                  fontSize: '10px',
                  whiteSpace: 'nowrap',
                  background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
                  border: 'none',
                  color: '#fff'
                }} disabled={!hasValidGpsUrl(currentVehicle)} onClick={e => { setThreeDaysBefore(); }}>
                  3 gün önce
                </Button>
              </Col>
            </Col>
          </Row>
          {vehicleHistory?.length > 0 && (() => {
            const first = new Date(vehicleHistory[0].ts);
            const last = new Date(vehicleHistory[vehicleHistory.length - 1].ts);
            const fmt = (d) => `${d.toLocaleDateString('tr-TR')} ${d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}`;
            return (
              <Row>
                <Col>
                  <div style={{ fontSize: '10px', color: '#5a9bd4', textAlign: 'right', padding: '2px 4px', opacity: 0.8 }}>
                    Gösterilen GPS verisi: {fmt(first)} — {fmt(last)}
                  </div>
                </Col>
              </Row>
            );
          })()}
          <Row>
            <Col>
              <ModeToggleButtons />
            </Col>
          </Row>
          </div>
        </div>
      </div>

      {/* Help Modal for measurement modes */}
      <Modal
        show={!!showHelpModal}
        onHide={() => setShowHelpModal(null)}
        centered
        size="sm"
      >
        <Modal.Header closeButton style={{
          background: '#000',
          borderBottom: `2px solid ${helpContent[showHelpModal]?.color || '#5a9bd4'}`,
          color: '#fff'
        }}>
          <Modal.Title style={{ fontSize: '16px', color: helpContent[showHelpModal]?.color || '#5a9bd4' }}>
            {helpContent[showHelpModal]?.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{
          background: '#000',
          color: '#fff',
          fontSize: '13px',
          lineHeight: '1.8'
        }}>
          {helpContent[showHelpModal]?.body.map((line, i) => (
            <div key={i} style={{ marginBottom: i === 0 ? 8 : 2 }}>
              {i === 0 ? <strong>{line}</strong> : line}
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer style={{
          background: '#000',
          borderTop: '1px solid rgba(20, 52, 92, 0.4)'
        }}>
          <Button size="sm" onClick={() => setShowHelpModal(null)} style={{
            background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
            border: 'none',
            color: '#fff'
          }}>
            Tamam
          </Button>
        </Modal.Footer>
      </Modal>

      <style jsx>{`
        @keyframes copyAnimation {
          0% { transform: scale(1); }
          50% { transform: scale(1.2); }
          100% { transform: scale(1); }
        }

        .animate-copy {
          animation: copyAnimation 0.5s ease;
        }

        @media (min-width: 768px) {
          #open-sidebar-button {
            display: none;
          }
          #left-pane {
            display: block;
          }
        }
        @media (max-width: 768px) {
          #open-sidebar-button {
            display: block;
          }
          #left-pane {
            display: none;
          }
          .map-legend {
            bottom: 10px;
          }
        }

        /* Responsive Overlay Styles */
        @media (max-width: 768px) {
          .logo-overlay {
            bottom: 10px !important;
            padding: 8px 15px !important;
          }
          .logo-overlay img {
            height: 35px !important;
          }
          .top-right-controls {
            top: 10px !important;
            right: 10px !important;
            gap: 8px !important;
          }
          .clock-container {
            display: none !important;
          }
          .top-right-controls button {
            font-size: 11px !important;
            padding: 8px 12px !important;
          }
          #open-sidebar-button {
            font-size: 11px !important;
            padding: 8px 12px !important;
          }
          /* Ensure consistent spacing from screen borders on mobile */
          #ayarlar-button-wrapper {
            top: 10px !important;
            left: 10px !important;
          }
        }
        .marker {
          cursor: move;
        }

        /* Google Maps InfoWindow styling */
        .gm-style .gm-style-iw-c {
          padding: 0 !important;
          border-radius: 10px !important;
          box-shadow: 0 8px 40px 0 rgba(20, 52, 92, 0.3) !important;
          background: #000 !important;
          border: 2px solid rgba(20, 52, 92, 0.4) !important;
        }
        .gm-style .gm-style-iw-d {
          overflow: hidden !important;
        }
        .gm-style .gm-style-iw-tc::after {
          background: #000 !important;
        }
        /* Move close button inside the content area */
        .gm-style .gm-style-iw-chr {
          position: absolute !important;
          top: 8px !important;
          right: 8px !important;
          z-index: 10 !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        .gm-style .gm-style-iw-chr button {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 20px !important;
          height: 20px !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        .gm-style .gm-style-iw-chr button span,
        .gm-style .gm-style-iw-chr button img {
          margin: 0 !important;
          position: static !important;
        }
      `}</style>

      {/* Fixed-position route info popup */}
      {routeInfoPopup && (() => {
        const route = routes.find(r => getRouteKey(r) === routeInfoPopup.routeId);
        const routeVehicle = route ? customerSummary?.vehicles[route.vehicleId] : null;
        if (!route || !routeVehicle) return null;
        return (
          <>
            <div style={{ position: 'fixed', inset: 0, zIndex: 9998 }} onClick={() => setRouteInfoPopup(null)} />
            <div style={{
              position: 'fixed', top: routeInfoPopup.top, left: routeInfoPopup.left,
              transform: 'translate(-100%, -50%)', marginLeft: -8,
              background: '#1a1a2e', border: '1px solid rgba(90,155,212,0.4)', borderRadius: '8px',
              padding: '10px 14px', zIndex: 9999, minWidth: '200px', whiteSpace: 'nowrap',
              boxShadow: '0 4px 20px rgba(0,0,0,0.5)'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4, gap: 12 }}>
                <span style={{ color: '#888', fontSize: '11px' }}>Plaka</span>
                {routeVehicle.plate ? (
                  <Button variant="link" style={{ padding: 0, fontSize: '13px', color: '#5a9bd4', textAlign: 'right' }} onClick={() => {
                    window.open(`http://${window.location.host}/vehicleDetailPart?vehicleId=${route.vehicleId}&plate=${encodeURIComponent(routeVehicle.plate || '')}`, `${routeVehicle.plate}`, 'width=900,height=750');
                  }}>{routeVehicle.plate}</Button>
                ) : <span style={{ color: '#6c757d', fontSize: '13px' }}>---</span>}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4, gap: 12 }}>
                <span style={{ color: '#888', fontSize: '11px' }}>Sürücü</span>
                {routeVehicle.driverName ? (
                  <Button variant="link" style={{ padding: 0, fontSize: '13px', color: '#5a9bd4', whiteSpace: 'nowrap', textAlign: 'right' }} onClick={() => {
                    window.open(`http://${window.location.host}/driverDetail?driverId=${routeVehicle.driverId || route.driverId}&driverName=${encodeURIComponent(routeVehicle.driverName || '')}`, `_blank`, 'width=900,height=900,popup=true');
                  }}>{routeVehicle.driverName}</Button>
                ) : <span style={{ color: '#6c757d', fontSize: '13px' }}>---</span>}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
                <span style={{ color: '#888', fontSize: '11px' }}>Tel</span>
                <span style={{ textAlign: 'right' }}>
                {routeVehicle.driverPhone ? (
                  <>
                    <a href={`tel:+90${routeVehicle.driverPhone}`} style={{ fontSize: '13px', color: '#5a9bd4' }}>{formatPhoneNumber(routeVehicle.driverPhone)}</a>
                    <FontAwesomeIcon
                      className={`copy-icon ${lastClickedIcon === `phone-${route._id}` ? 'animate-copy' : ''}`}
                      icon={faCopy} color="#5a9bd4"
                      style={{ marginLeft: '5px', cursor: 'pointer', fontSize: '11px' }}
                      onClick={() => {
                        navigator.clipboard.writeText(`+90${routeVehicle.driverPhone}`);
                        setLastClickedIcon(`phone-${route._id}`);
                        setTimeout(() => setLastClickedIcon(null), 500);
                      }}
                    />
                  </>
                ) : <span style={{ color: '#6c757d', fontSize: '13px' }}>---</span>}
                </span>
              </div>
            </div>
          </>
        );
      })()}

      {/* Fixed-position GPS warning popup */}
      {gpsWarningPopup && (
        <>
          <div style={{ position: 'fixed', inset: 0, zIndex: 9998 }} onClick={() => setGpsWarningPopup(null)} />
          <div style={{
            position: 'fixed', top: gpsWarningPopup.top, left: gpsWarningPopup.left,
            transform: 'translate(-50%, -50%)',
            background: '#1a1a2e', border: '1px solid rgba(255,107,107,0.4)', borderRadius: '8px',
            padding: '10px 14px', zIndex: 9999, width: 'fit-content', maxWidth: 260,
            boxShadow: '0 4px 20px rgba(0,0,0,0.5)'
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <FontAwesomeIcon icon={faExclamationCircle} style={{ color: '#ff6b6b', fontSize: '14px', marginTop: 2, flexShrink: 0 }} />
              <span style={{ color: '#ff6b6b', fontSize: '13px', flex: 1 }}>Bu araca ait GPS verisi bulunamadı</span>
              <FontAwesomeIcon
                icon={faTimes}
                style={{ color: '#888', fontSize: '13px', cursor: 'pointer', marginTop: 2, flexShrink: 0 }}
                onClick={() => setGpsWarningPopup(null)}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CustomerVehicleDetail;
